import React, { useState, useMemo, useRef, useEffect } from "react";
import _ from "lodash";
import { CircularProgress, Menu, MenuItem } from "@material-ui/core";
import { TLUserPreferences, Tldraw as NewTldraw, useTldrawUser, TldrawOptions, TLShapeId } from "@tldraw/tldraw";
import { useJsApiLoader } from "@react-google-maps/api";
import { SnackBarContext } from "components/snack-bar";
import CONFIG from "config/config";
import ROUTES, { ADM_ROUTING, EDDM_ROUTING } from "config/routing";
import cn from "classnames";
import {
  extractIDsFromURL,
  getOrientationStorageKey,
  getStoredOrientation,
  setStoredOrientation,
} from "pages/flyer/builder/utils/orientationStorage";
import { gtagWrapper, checkIsNeedUpdateLastActiveStepState } from "utils";
import { useHistory } from "react-router";
import { generatePath, useLocation, useParams } from "react-router-dom";
import backIcon from "static/media/back.svg";
import "tldraw/tldraw.css";
import "./state/newShapes/shapeHitarea.css";
import { CAMPAIGN_ENUM_TYPES, CAMPAIGN_SUBTYPES_ENUM, DMDocumentFormats, ADMDocumentFormats } from "shared/constants";
import { ADM_STEP } from "campaign-builder/domain/constants";
import WebFont from "webfontloader";
import { useBrandKitStore } from "store/brandKit";
import SideBar from "pages/flyer/builder/components/SideBar";
import { ContextMenu } from "pages/flyer/builder/drawer/components/ContextMenu";
import { FocusButton } from "pages/flyer/builder/drawer/components/FocusButton";
import { Loading, LoadingUI } from "pages/flyer/builder/drawer/components/Loading";
import { OrientationChangeLoader } from "pages/flyer/builder/drawer/components/OrientationChangeLoader/OrientationChangeLoader";
import { TldrawContext, useKeyboardShortcuts, useStylesheet, useTldrawApp } from "pages/flyer/builder/drawer/hooks";
import { useMaskShapeEditMode } from "pages/flyer/builder/drawer/hooks/useMaskShapeEditMode";
import { useMaskShapeSync } from "pages/flyer/builder/drawer/hooks/useMaskShapeSync";
import { useMaskGroupListener } from "pages/flyer/builder/drawer/hooks/useMaskGroupListener";
import { HideSelectionOnChange } from "pages/flyer/builder/drawer/hooks/useHideSelectionOnChange";
import { ResizeCursorManager } from "pages/flyer/builder/drawer/hooks/useResizeCursor";
import { ScaleResizeCursorManager } from "pages/flyer/builder/drawer/new-tldraw-components/scaleResizeCursors";
import { TDCallbacks, TldrawApp } from "pages/flyer/builder/drawer/state";
import { TLDR } from "pages/flyer/builder/drawer/state/TLDR";
import { StyledLayout, StyledLoader, StyledUI } from "pages/flyer/builder/drawer/styled";
import { dark } from "pages/flyer/builder/drawer/styles";
import { DocumentOrientation, GtagOptions, TDDocument, TDShapeType, TDStatus } from "pages/flyer/builder/drawer/types";
import useStyles from "pages/flyer/builder/drawer/useStyles";
import ConfirmPopup from "pages/flyer/builder/drawer/components/ConfirmPopup";
import Header from "components/header";
import _jsonSnapshot from "./snapshot.json";
import { updateCampaignExtraData, getCampaign } from "../../../../graphQL";
import { CAMPAIGN_INTERNAL_STATUSES } from "../../../constants";
import BlockingOverlay from "../../../../components/BlockingOverlay";
import { useStore } from "../../../../store";
import { StoreType } from "../../../../store/types";
import { authorization } from "../../../../module/auth";
import { injectGuestPlaceholders } from "pages/flyer/builder/utils/guestPlaceholders";
import { copyGuestStateToAuthedRoom } from "pages/flyer/builder/utils/copyGuestState";
import { getAuthedRoomId } from "pages/flyer/builder/utils";
import { addFlyerBuilderStates } from "graphQL/mutations/flyerBuilderStates";
import { useIsBuilderEmptyState } from "pages/flyer/builder/hooks/useIsBuilderEmptyState";
import SignupModal from "components/GuestModals/SignupModal";
import FeatureModal, { FeatureModalType } from "components/GuestModals/FeatureModal";
import LeaveWarningModal from "components/GuestModals/LeaveWarningModal";
import CustomStylePanel from "./components/TldrawStylePanel";
import {
  CustomCheckboxTool,
  CustomCloudTool,
  CustomEllipseTool,
  CustomHeartTool,
  CustomOvalTool,
  CustomRectangleTool,
  CustomStarTool,
  CustomTextTool,
  CustomTriangleTool,
  CustomXBoxTool,
} from "../components/SideBar/Aside/components/Shapes/RegisterTools";
import { FormatUtilFront } from "./state/format-shapes/FormatUtil";
import { BoxForTemplateUtilFront } from "./state/format-shapes/BoxForTemplateUtil";
import { FormatDashBorderFront } from "./state/format-shapes/FormatDashBorderUtil";
import { CustomCloudUtil } from "./state/newShapes/CustomCloudUtil";
import { CustomHeartUtil } from "./state/newShapes/CustomHeartUtil";
import { CustomEllipseUtil } from "./state/newShapes/CustomEllipseUtil";
import { CustomOvalUtil } from "./state/newShapes/CustomOvalUtil";
import { CustomRectUtil } from "./state/newShapes/CustomRectUtil";
import { CustomTriangleUtil } from "./state/newShapes/CustomTriangleUtil";
import { CustomStarUtil } from "./state/newShapes/CustomStarUtil";
import { CustomCheckBoxUtil } from "./state/newShapes/CustomCheckboxUtil";
import { CustomXBoxUtil } from "./state/newShapes/CustomXBoxUtil";
import { uiOverrides } from "../components/SideBar/Aside/components/Shapes/UiOverrides";
import { CustomTextUtil } from "./state/newShapes/CustomTextUtil/CustomTextUtil";
import { CustomSvgUtil } from "./state/newShapes/CustomSvgUtil";
import { CustomImageUtil } from "./state/newShapes/CustomImageUtil/CustomImageUtil";
import { CustomAddressBoxUtil } from "./state/newShapes/CustomAddressBoxUtil";
import { AddressBoxWarningModal } from "./components/AddressBoxWarningModal";
import { isADMFormat, isEDDMFormat } from "utils/formats";
import { shapesAddressBox } from "../components/SideBar/Aside/components/Settings/snapshots/addressBox";
import { shapesAddressBoxEddm } from "../components/SideBar/Aside/components/Settings/snapshots/addressBoxEddm";
import BottomToolPanel from "./new-tldraw-components/BottomToolPanel";
import Measure from "./new-tldraw-components/Measure";
import { CustomMeasureUtil } from "./state/newShapes/CustomMeasureUtil";
import { useFontsContext } from "./contexts/FontsContext";
import { LabelUtil } from "./state/format-shapes/LabelUtil";
import { RedLineUtil } from "./state/format-shapes/RedLineUtil";
import { FoldLineUtil } from "./state/format-shapes/FoldLineUtil";
import { BlackLineUtil } from "./state/format-shapes/BlackLineUtil";
import { CustomContextMenu } from "../components/SideBar/Aside/NodesList/CustomContextMenu";
import { SECTIONS } from "../constants";
import { ResizingOverlay } from "./components/ResizingOverlay";
import { CommentsOverlay } from "./components/Comments/CommentsOverlay";
import { useCommentsStore } from "store/comments";

import { DrawShapeUtil } from "./state/newShapes/draw/DrawShapeUtil";
import { DrawShapeTool } from "./state/newShapes/draw/DrawShapeTool";
import { HighlightShapeUtil } from "./state/newShapes/draw/HighlightShapeUtil";
import { HighlightShapeTool } from "./state/newShapes/Highlight/toolStates/HighlightShapeTool";
import { DoorHangerUtil } from "./state/format-shapes/DoorHangerUtil";
import simpleHtmlExport from "./new-tldraw-components/simpleHtmlExport";
import ExportButton from "../components/ExportButton";
import TemplateModal from "../../../creative/pageV2/components/TemplateModal";
import useDesignManagement, { DesignTemplate, DesignSource } from "../../../creative/pageV2/useDesignManagement";
import { generateFileFromService } from "../../../../module/puppeteerService/generatePDF";
import { getFormatDimensionsWithFallback } from "../utils/formatDimensions";
import ChangesSaved from "../../../../components/ChangesSaved/ChangesSaved";
import FlyerBuilderEmptyState from "../components/FlyerBuilderEmptyState";
import { TourProvider, flyerBuilderTourSteps } from "components/Tour";
import DesignNameInput from "../../../../components/DesignNameInput";
import isValidUrl from "utils/isValidurl";
import { importPdfFile } from "../components/SideBar/Aside/components/PDFImport";
import { usePDFUpload } from "./contexts/PDFUploadContext";
import SimpleFontManager from "./components/SimpleFontManager";
import { ColorPickerProvider } from "./components/ColorPickerContext";
import { convertLegacyTldrawData, LegacyTldrawData, ModernTldrawData } from "./utils/legacyConverter";
import { createShapeId, AssetRecordType, loadSnapshot } from "@tldraw/editor";
// NOTE: QRCodeDuplicateWarning disabled - duplicating QR codes is allowed.
// Keep commented in case it needs to be re-enabled in the future.
// import { QRCodeDuplicateWarning } from "./components/QRCodeDuplicateWarning";
import { CanvasDragOverlay } from "./components/CanvasDragOverlay";
import { ContextMenuClamp } from "./components/ContextMenuClamp";
const libraries: any = ["geometry", "places", "drawing"];

/** First-time tour wrapper — shows automatically for first design, re-triggerable via help button */
const getTourKey = () => {
  try {
    const user = authorization.getUser();
    return `flyerBuilderTourCompleted_${user?.id || "anon"}`;
  } catch {
    return "flyerBuilderTourCompleted";
  }
};

const FlyerBuilderTour: React.FC = () => {
  const [active, setActive] = React.useState(false);
  const handleComplete = React.useCallback(() => {
    setActive(false);
    try {
      localStorage.setItem(getTourKey(), "true");
    } catch {
      /* ignore */
    }
  }, []);

  // Auto-start tour for first-time users:
  // 1. localStorage check (fast, same browser)
  // 2. API check via flyer API — does the user have any existing designs? (cross-browser)
  //
  // Guests are intentionally skipped here: their builder lands on the
  // placeholder PDF (front + back image shapes) which is meant to feel
  // like a "preview" of what they'll get, not a blank canvas to learn.
  // The tour pops up only when they explicitly click "+ New Design"
  // (which dispatches `tour:start` from Settings.tsx) and the canvas
  // becomes a real editable surface.
  React.useEffect(() => {
    let cancelled = false;

    const checkAndStart = async () => {
      // Skip auto-start for unauthenticated guests — see comment above.
      try {
        const auth = await import("module/auth");
        if (!auth.authorization.getUser?.()?.id) return;
      } catch {
        /* if the auth module fails to import, fall through to normal flow */
      }

      // Fast check: localStorage
      try {
        const stored = localStorage.getItem(getTourKey());
        console.log("[Tour] localStorage check:", getTourKey(), "=", stored);
        if (stored) return;
      } catch {
        /* ignore */
      }

      // Cross-browser check: does the user have any existing designs?
      try {
        const auth = await import("module/auth");
        const user = auth.authorization.getUser();
        const clientId = user?.clientId;
        console.log("[Tour] clientId:", clientId);
        if (clientId) {
          const gql = await import("module/graphQL");
          const config = await import("config/config");
          const res = await gql.callAuthorizedGraphQLEndpoint(
            `query { getDesigns(clientId: "${clientId}", pagination: { page: 1, limit: 2 }) { designs { id } } }`,
            {},
            config.default.FLYER_API_URL
          );
          const data = await (res as any).json();
          const designs = data?.data?.getDesigns?.designs || [];
          console.log("[Tour] getDesigns response:", designs.length, "designs", designs);
          if (designs.length > 1) {
            try {
              localStorage.setItem(getTourKey(), "true");
            } catch {
              /* ignore */
            }
            return;
          }
        }
      } catch (err) {
        console.warn("[Tour] API check failed:", err);
      }

      // No designs found — show the tour
      if (!cancelled) {
        setTimeout(() => {
          if (!cancelled) setActive(true);
        }, 1000);
      }
    };

    checkAndStart();
    return () => {
      cancelled = true;
    };
  }, []);

  // Listen for re-trigger from help button
  React.useEffect(() => {
    const handleRetrigger = () => {
      setActive(true);
    };
    window.addEventListener("tour:start", handleRetrigger);
    return () => window.removeEventListener("tour:start", handleRetrigger);
  }, []);

  // Listen to tldraw store for new shapes — dispatch tour:shape-created
  React.useEffect(() => {
    if (!active) return;

    // Poll for editor reference (stored on window by onMount)
    const checkEditor = setInterval(() => {
      const editor = (window as any).__tldrawEditorForFontFix;
      if (!editor?.store) return;

      clearInterval(checkEditor);

      const SYSTEM_SHAPE_TYPES = new Set([
        "format",
        "customLabel",
        "redLine",
        "blackLine",
        "dash-border",
        "foldLine",
        "doorHanger",
        "custom-box",
      ]);

      let pendingShapeCreated = false;

      const handleMouseUp = () => {
        if (pendingShapeCreated) {
          pendingShapeCreated = false;
          document.body.dispatchEvent(new CustomEvent("tour:shape-created"));
        }
      };
      window.addEventListener("mouseup", handleMouseUp);

      const unsubscribe = editor.store.listen(
        ({ changes }: any) => {
          if (changes.added && Object.keys(changes.added).length > 0) {
            const hasUserShape = Object.values(changes.added).some(
              (shape: any) => shape.typeName === "shape" && !SYSTEM_SHAPE_TYPES.has(shape.type)
            );
            if (hasUserShape) {
              // Check if mouse is currently pressed (user is dragging to size the shape)
              // If not pressed, dispatch immediately with a small delay for the click to complete
              pendingShapeCreated = true;
              // Short delay covers single-click creation (mouseup already happened)
              setTimeout(() => {
                if (pendingShapeCreated) {
                  pendingShapeCreated = false;
                  document.body.dispatchEvent(new CustomEvent("tour:shape-created"));
                }
              }, 300);
            }
          }
        },
        { source: "user", scope: "document" }
      );

      (window as any).__tourMouseUpCleanup = () => window.removeEventListener("mouseup", handleMouseUp);

      // Track text editing and selection state
      let wasEditing = false;
      let hadSelection = false;
      const statePoll = setInterval(() => {
        // Dispatch tour:text-completed when user exits edit mode
        const isEditing = !!editor.getEditingShapeId();
        if (wasEditing && !isEditing) {
          document.body.dispatchEvent(new CustomEvent("tour:text-completed"));
        }
        wasEditing = isEditing;

        // Dispatch tour:selection-cleared when user deselects all shapes
        const hasSelection = editor.getSelectedShapeIds().length > 0;
        if (hadSelection && !hasSelection) {
          document.body.dispatchEvent(new CustomEvent("tour:selection-cleared"));
        }
        hadSelection = hasSelection;
      }, 200);
      (window as any).__tourTextEditPoll = statePoll;

      // Store cleanup for when effect unmounts
      (window as any).__tourStoreUnsub = unsubscribe;
    }, 200);

    return () => {
      clearInterval(checkEditor);
      const unsub = (window as any).__tourStoreUnsub;
      if (unsub) {
        unsub();
        delete (window as any).__tourStoreUnsub;
      }
      const mouseUpCleanup = (window as any).__tourMouseUpCleanup;
      if (mouseUpCleanup) {
        mouseUpCleanup();
        delete (window as any).__tourMouseUpCleanup;
      }
      const textEditPoll = (window as any).__tourTextEditPoll;
      if (textEditPoll) {
        clearInterval(textEditPoll);
        delete (window as any).__tourTextEditPoll;
      }
    };
  }, [active]);

  return <TourProvider steps={flyerBuilderTourSteps} active={active} onComplete={handleComplete} />;
};

const ADDRESS_BOX_ID = "shape:addressBox" as TLShapeId;
const USPS_COMPLIANT_FORMATS = new Set<string>([
  ...Object.values(DMDocumentFormats),
  ...Object.values(ADMDocumentFormats),
]);

const bodyMutationCallback = (mutationList: any) => {
  for (const mutation of mutationList) {
    if (mutation.type === "attributes" && mutation.attributeName === "data-scroll-locked") {
      window.document.body.removeAttribute("data-scroll-locked");
    }
  }
};

export interface TldrawProps extends TDCallbacks {
  /**
   * (optional) If provided, the component will load / persist state under this key.
   */
  id?: string;

  /**
   * The design id.
   */
  designId: string;

  /**
   * (optional) The document to load or update from.
   */
  document?: TDDocument;

  /**
   * (optional) The current page id.
   */
  currentPageId?: string;

  /**
   * (optional) Whether the editor should immediately receive focus. Defaults to true.
   */
  autofocus?: boolean;

  /**
   * (optional) Whether to show the menu UI.
   */
  showMenu?: boolean;

  /**
   * (optional) Whether to show the pages UI.
   */
  showPages?: boolean;

  /**
   * (optional) Whether to show the styles UI.
   */
  showStyles?: boolean;

  /**
   * (optional) Whether to show the zoom UI.
   */
  showZoom?: boolean;

  /**
   * (optional) Whether to show the tools UI.
   */
  showTools?: boolean;

  /**
   * (optional) Whether to show a sponsor link for Tldraw.
   */
  showSponsorLink?: boolean;

  /**
   * (optional) Whether to show the UI.
   */
  showUI?: boolean;

  /**
   * (optional) Whether to the document should be read only.
   */
  readOnly?: boolean;

  /**
   * (optional) Whether to to show the app's dark mode UI.
   */
  darkMode?: boolean;

  /**
   * (optional) If provided, image/video componnets will be disabled.
   *
   * Warning: Keeping this enabled for multiplayer applications without provifing a storage
   * bucket based solution will cause massive base64 string to be written to the liveblocks room.
   */
  disableAssets?: boolean;

  loading: boolean;
  tlStore: any;
}

export function Tldraw({
  id,
  designId,
  loading,
  document,
  currentPageId,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  darkMode = false,
  autofocus = true,
  showMenu = false,
  showPages = false,
  showTools = false,
  showZoom = true,
  showStyles = true,
  showUI = true,
  readOnly = false,
  showSponsorLink = false,
  disableAssets = false,
  onMount,
  onChange,
  onChangePresence,
  onNewProject,
  onSaveProject,
  onSaveProjectAs,
  onOpenProject,
  onOpenMedia,
  onSignOut,
  onSignIn,
  onUndo,
  onRedo,
  onPersist,
  onPatch,
  onCommand,
  onChangePage,
  onChangeDocumentFormat,
  onAssetCreate,
  onAssetDelete,
  onExport,
  saveFlyerBuilderStates,
  tlStore,
}: TldrawProps) {
  const [sId, setSId] = React.useState(id);
  const {
    campaign: { flyerType },
    flyerBuilder: { loading: flyerBuilderLoading },
  }: StoreType = useStore();

  React.useEffect(() => {
    // Load Bebas Neue + Inconsolata once per session. Guarded against double
    // load when this component remounts (Liveblocks suspense, etc.) — without
    // the guard each remount re-issued the CSS request, contributing to the
    // "fonts refetch on every action" symptom.
    if (typeof window !== "undefined" && !(window as any).__tldrawCoreFontsLoaded) {
      WebFont.load({
        google: {
          families: ["Bebas Neue", "Inconsolata"],
        },
      });
      (window as any).__tldrawCoreFontsLoaded = true;
    }

    // NOTE: Previously this effect appended three `<meta http-equiv>` tags
    // (Cache-Control: no-store, Pragma: no-cache, Expires: 0) to force a
    // "no cache" policy on the Tldraw view. Per the HTML spec those metas
    // only affect the document itself — and even there modern browsers
    // largely ignore them. BUT Chrome has historically respected
    // `Pragma: no-cache` for *stylesheet revalidation*, which caused every
    // `<link rel="stylesheet">` (including the ~15 Google Fonts chunks
    // loaded by `useGoogleFonts`) to be re-requested whenever this
    // component re-mounted. Combined with Tldraw remounting on certain
    // store / suspense transitions, that produced the observed
    // "fonts refetch on every action" pattern. The metas served no real
    // purpose (no caching directive that browsers honor here) so the
    // safest fix is to remove them entirely.
  }, []);

  React.useEffect(() => {
    const observer = new MutationObserver(bodyMutationCallback);
    const targetNode = window.document.body;
    const config = { attributes: true, childList: true, subtree: true };
    observer.observe(targetNode, config);

    return () => {
      observer.disconnect();
    };
  }, []);

  const [app, setApp] = React.useState(() => {
    const app = new TldrawApp(
      id,
      {
        onMount,
        onChange,
        onChangePresence,
        onNewProject,
        onSaveProject,
        onSaveProjectAs,
        onOpenProject,
        onOpenMedia,
        onSignOut,
        onSignIn,
        onUndo,
        onRedo,
        onPersist,
        onPatch,
        onCommand,
        onChangePage,
        onChangeDocumentFormat,
        onAssetDelete,
        onAssetCreate,
      },
      {
        format: flyerType,
      }
    );
    return app;
  });

  // Create a new app if the `id` prop changes.
  React.useEffect(() => {
    if (id === sId) return;

    const newApp = new TldrawApp(id, {
      onMount,
      onChange,
      onChangePresence,
      onNewProject,
      onSaveProject,
      onSaveProjectAs,
      onOpenProject,
      onOpenMedia,
      onSignOut,
      onSignIn,
      onUndo,
      onRedo,
      onPersist,
      onPatch,
      onCommand,
      onChangePage,
      onChangeDocumentFormat,
      onAssetDelete,
      onAssetCreate,
      onExport,
    });
    setSId(id);
    setApp(newApp);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sId, id]);

  // Update the document if the `document` prop changes but the ids,
  // are the same, or else load a new document if the ids are different.
  React.useEffect(() => {
    if (!document) return;
    if (document.id === app.document.id) {
      app.updateDocument(document);
    } else {
      app.loadDocument(document);
    }
  }, [document, app]);

  // Disable assets when the `disableAssets` prop changes.
  React.useEffect(() => {
    app.setDisableAssets(disableAssets);
  }, [app, disableAssets]);

  // Change the page when the `currentPageId` prop changes.
  React.useEffect(() => {
    if (!currentPageId) return;
    app.changePage(currentPageId);
  }, [currentPageId, app]);

  // Toggle the app's readOnly mode when the `readOnly` prop changes.
  React.useEffect(() => {
    app.readOnly = readOnly;
  }, [app, readOnly]);

  // Update the app's callbacks when any callback changes.
  React.useEffect(() => {
    app.callbacks = {
      onMount,
      onChange,
      onChangePresence,
      onNewProject,
      onSaveProject,
      onSaveProjectAs,
      onOpenProject,
      onOpenMedia,
      onSignOut,
      onSignIn,
      onUndo,
      onRedo,
      onPersist,
      onPatch,
      onCommand,
      onChangePage,
      onChangeDocumentFormat,
      onAssetDelete,
      onAssetCreate,
      onExport,
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    onMount,
    onChange,
    onChangePresence,
    onNewProject,
    onSaveProject,
    onSaveProjectAs,
    onOpenProject,
    onOpenMedia,
    onSignOut,
    onSignIn,
    onUndo,
    onRedo,
    onPersist,
    onPatch,
    onCommand,
    onChangePage,
    onChangeDocumentFormat,
    onAssetDelete,
    onAssetCreate,
    onExport,
  ]);

  // Use the `key` to ensure that new selector hooks are made when the id changes
  return (
    <TldrawContext.Provider value={app}>
      <ColorPickerProvider>
        {/* {(loading || flyerBuilderLoading) && (
          <StyledLoader>
            <CircularProgress color="secondary" />
          </StyledLoader>
        )} */}
        <InnerTldraw
          designId={designId}
          tlStore={tlStore}
          key={sId || "Tldraw"}
          id={sId}
          autofocus={autofocus}
          showPages={showPages}
          showMenu={showMenu}
          showStyles={showStyles}
          showZoom={showZoom}
          showTools={showTools}
          showUI={showUI}
          showSponsorLink={showSponsorLink}
          readOnly={readOnly}
          loading={loading}
          saveFlyerBuilderStates={saveFlyerBuilderStates}
          onAssetCreate={onAssetCreate}
        />
      </ColorPickerProvider>
    </TldrawContext.Provider>
  );
}

interface InnerTldrawProps {
  id?: string;
  designId: string;
  autofocus: boolean;
  showPages: boolean;
  showMenu: boolean;
  showZoom: boolean;
  showStyles: boolean;
  showUI: boolean;
  showTools: boolean;
  showSponsorLink: boolean;
  readOnly: boolean;
  loading: boolean;
  saveFlyerBuilderStates?: () => void;
  tlStore: any;
  onAssetCreate?: (file: File, id: string) => Promise<string | false>;
}

const InnerTldraw = React.memo(function InnerTldraw({
  id,
  designId,
  autofocus,
  showPages,
  showMenu,
  showZoom,
  showStyles,
  showTools,
  showSponsorLink,
  readOnly,
  showUI,
  loading,
  saveFlyerBuilderStates,
  tlStore,
  onAssetCreate,
}: InnerTldrawProps) {
  const { format, countryCode } = useParams() as { format?: string; countryCode?: string };
  const searchParams = new URLSearchParams(window.location.search);
  const isIntegrated = searchParams.get("variant") === "integrated";
  const workflowUuid = useRef(searchParams.get("workflowUuid")).current;
  const isPublicBuilder = location.pathname.includes(`${ROUTES.PUBLIC_FLYER_BUILDER.split("/")[1]}/`);
  const isGuest = isPublicBuilder && !authorization.getUser()?.id;
  const [isSignupModalOpen, setIsSignupModalOpen] = React.useState(false);
  const [featureModalType, setFeatureModalType] = React.useState<FeatureModalType | null>(null);
  // True from the moment `guest-signup-complete` fires until the
  // post-signup redirect actually navigates the page away. Drives the
  // full-screen `LoadingUI` overlay so the user sees the same animated
  // loader the rest of the builder uses (instead of staring at the
  // freshly-closed signup modal + raw canvas for the ~1-3s of
  // copy/seed/redirect work).
  const [isPostSignupLoading, setIsPostSignupLoading] = React.useState(false);
  // When set, render a CTA (instead of the loader) that opens the just-claimed
  // design in a NEW tab on click — a user gesture, so it isn't popup-blocked
  // and the host marketing page stays intact.
  const [postSignupUrl, setPostSignupUrl] = React.useState<string | null>(null);
  // True only on the very first authed builder load after a guest
  // carry-over (the redirect tags the URL with `?fromGuestCarry=true`).
  // Drives the back-button → dropdown swap below: the user came from
  // a guest signup, so "where do I go back to?" has two distinct
  // answers (marketing site vs. platform dashboard) rather than the
  // iframe postMessage flow used for regular client navigation.
  const isFromGuestCarry = React.useMemo(
    () => new URLSearchParams(window.location.search).get("fromGuestCarry") === "true",
    []
  );
  const [backMenuAnchor, setBackMenuAnchor] = React.useState<HTMLElement | null>(null);
  // Confirmation modal shown when a guest clicks the header Back
  // button. Their work lives only in the guest Liveblocks room until
  // they register, so leaving without signing up loses it — we ask
  // before redirecting away.
  const [showGuestLeaveWarning, setShowGuestLeaveWarning] = React.useState(false);
  const routerHistory = useHistory();

  // Listener attached further below — see "Post-signup redirect" useEffect
  // after `editorInstance` is declared. Keeping it there avoids the
  // temporal-dead-zone error on initial render.

  // Handle messages from parent window (when in iframe)
  React.useEffect(() => {
    // post to the iframe parent
    window.parent.postMessage(
      {
        type: "openFlyerBuilder",
        data: {
          designId: designId,
          format: format,
        },
      },
      "*"
    );
  }, [designId, format]);

  // Additional cache prevention for Tldraw component
  React.useEffect(() => {
    // Force component refresh by updating URL with cache bust parameter
    if (typeof window !== "undefined") {
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set("_tldraw_cache_bust", Date.now().toString());

      // Only update if not already present
      if (!currentUrl.searchParams.has("_tldraw_cache_bust")) {
        window.history.replaceState({}, "", currentUrl.toString());
      }

      // Clear any Tldraw-specific caches
      if ((window as any).tldraw && (window as any).tldraw.app) {
        try {
          // Clear Tldraw internal caches
          (window as any).tldraw.app.store.clear();
        } catch (error) {
          console.log("Could not clear Tldraw cache:", error);
        }
      }
    }
  }, []);

  // Ensure designId is available in URL params for Settings component
  React.useEffect(() => {
    if (designId && !isPublicBuilder) {
      const currentSearch = new URLSearchParams(window.location.search);
      if (!currentSearch.has("designId")) {
        currentSearch.set("designId", designId);
        // Use React Router's history.replace to update URL so React Router detects the change
        routerHistory.replace({
          search: currentSearch.toString(),
        });
      }
    }
  }, [designId, isPublicBuilder, routerHistory]);

  const app = useTldrawApp();
  const {
    campaign,
    user: { id: userId },
    client: { id: clientId },
    updateCampaign,
    updateErrors,
    isAddressBoxVisible,
  }: StoreType = useStore();
  const { id: campaignId, qrCodeLink = "", isSubmitted, channel, subtype, lastActiveStep, flyerType } = campaign;

  const styles = useStyles();

  const rWrapper = React.useRef<HTMLDivElement>(null);

  // Track empty-state so non-React event listeners (drag-and-drop) can read it
  const isEmptyStateRef = React.useRef(false);
  const tldrawLocation = useLocation();
  React.useEffect(() => {
    const isNewDesign = new URLSearchParams(tldrawLocation.search).get("newDesign") === "true";
    // Guests skip the format-selector empty state unless they explicitly
    // opt in via "+ New Design". Mirrors the logic in useIsBuilderEmptyState.
    if (isGuest && !isNewDesign) {
      isEmptyStateRef.current = false;
      return;
    }
    isEmptyStateRef.current = !flyerType || isNewDesign;
  }, [flyerType, isGuest, tldrawLocation.search]);

  // Initialize mask shape edit mode listener for double-click editing
  const [editorInstance, setEditorInstance] = React.useState<any>(null);
  useMaskShapeEditMode(editorInstance);
  useMaskShapeSync(editorInstance); // Sync mask shape and group positions
  useMaskGroupListener(editorInstance); // Real-time clip-path updates

  // Post-signup redirect: when SignupModal finishes the signup + claim, it
  // dispatches `guest-signup-complete` with the new designId. We stay on
  // the campaign-builder origin (same window) but reload into the
  // authenticated builder URL for the just-claimed design. Auth carries
  // over via `localStorage['apiKey']` + `localStorage['user']`, which
  // `authorization.login(...)` already wrote during the signup flow — same
  // origin, no cross-port handshake needed.
  //
  // Placed AFTER `editorInstance` is declared so the closure can reference
  // it without hitting a temporal-dead-zone error on initial render.
  React.useEffect(() => {
    if (!isPublicBuilder) return;
    const handler = async (event: Event) => {
      const detail = (event as CustomEvent).detail || {};
      // Surface the full-screen loader for the entire copy/seed/redirect
      // window. Never reset to false: the redirect at the bottom tears
      // down the page, and the new builder mount has its own loading
      // surface — leaving this true keeps the overlay covering until
      // navigation actually happens.
      setIsPostSignupLoading(true);
      const claimedDesignId = detail.designId;
      const claimedFormat = detail.format || format || "TEARAWAY";
      const cc = countryCode || "US";

      if (!claimedDesignId) {
        // Claim failed — at least the user is authed. Drop them on the
        // empty-state of the builder so they can start fresh.
        console.warn("[guest-signup-complete] no designId — reloading current URL with newDesign flag", detail);
        const url = new URL(window.location.href);
        url.searchParams.set("newDesign", "true");
        window.location.href = url.toString();
        return;
      }

      // Preserve the guest's in-progress canvas: copy the current editor
      // state to MongoDB under the authed roomId BEFORE redirecting. Once
      // the redirect happens, the new builder instance reads from
      // FlyerBuilderState by the authed key, so the rows have to be there.
      // Best-effort — a copy failure shouldn't block signup.
      try {
        await copyGuestStateToAuthedRoom(editorInstance, claimedDesignId);
      } catch (copyErr: any) {
        console.warn("[guest-signup-complete] state copy threw:", copyErr?.message || copyErr);
      }

      // Carry the guest's selected orientation across to the authed
      // design. The orientation storage key is suffixed with the URL's
      // id segment — for guests that's the roomId (== `designId` prop
      // here, since the route reuses the same param name), for authed
      // it's the new CampaignDesign id. Without this copy the authed
      // builder would not find an entry under `flyerOrientation_<newId>`
      // and fall back to Portrait, which is wrong for anything the
      // guest set to Landscape (e.g. a 9×6 postcard).
      //
      // ALSO sets a "pinned" flag so `PublicBuilder`'s post-mount
      // FlyerBuilderState prefetch doesn't overwrite the value with
      // whatever MongoDB has (the fresh authed room is born with the
      // default `Portrait` and would clobber our Landscape carry a
      // beat after the page renders correctly — exactly the flip the
      // user saw). The pin is one-shot; `PublicBuilder` clears it
      // after honoring it once.
      try {
        // `undefined` as the default so an absent localStorage entry
        // surfaces as a falsy `guestOrientation` (the `if` below skips
        // the carry+seed entirely in that case) — passing `""` here
        // would clash with the `DocumentOrientation` type and only
        // worked by accident before.
        const guestOrientation = getStoredOrientation(designId, null, undefined);
        if (guestOrientation) {
          setStoredOrientation(guestOrientation, String(claimedDesignId), null);
          try {
            window.localStorage.setItem(`flyerOrientationPinned_${claimedDesignId}`, "true");
          } catch {
            /* localStorage unavailable — pin not set, prefetch may overwrite */
          }

          // Seed MongoDB's FlyerBuilderState for the new authed room with
          // the carried orientation. Without this, `LiveStorage.recoverFromServer`
          // (called by useMultiplayerState.setupDocument post-mount) finds
          // no FlyerBuilderState row, falls back to `addToServer` with the
          // class's in-memory defaults (orientation: Portrait), and then
          // `setupDocument` reads the just-seeded Portrait back and writes
          // it to both localStorage AND the Zustand store — clobbering
          // our carried Landscape a beat after the page renders correctly.
          // By seeding first, recoverFromServer finds our row and the
          // whole downstream chain reads the right value.
          try {
            await addFlyerBuilderStates({
              key: getAuthedRoomId(claimedDesignId),
              states: {
                shapes: [],
                bindings: [],
                assets: [],
                documentSettings: {
                  format: claimedFormat as any,
                  orientation: guestOrientation as DocumentOrientation,
                  isShowGuidelines: true,
                },
              },
            });
          } catch (seedErr: any) {
            console.warn("[guest-signup-complete] FlyerBuilderState seed failed:", seedErr?.message || seedErr);
          }
        }
      } catch (orientErr: any) {
        console.warn("[guest-signup-complete] orientation carry-over failed:", orientErr?.message || orientErr);
      }

      const cacheBust = Date.now().toString();
      // `fromGuestCarry=true` lets the authed builder render the back
      // button as a dropdown ("Return to website" / "Return to home"
      // — see the `BackButton` block below) instead of the iframe-
      // parent postMessage flow used by the regular client builder
      // landing. Only present on the very first mount post-signup;
      // any subsequent navigation drops the param.
      const url =
        `${window.location.origin}/design/${cc}/${claimedDesignId}/${claimedFormat}/builder` +
        `?variant=integrated&action=edit&fileLink=&hasHtmlContent=false` +
        `&fromGuestCarry=true&cacheBust=${cacheBust}&timestamp=${cacheBust}`;
      // Don't navigate the frame or auto-open a tab (a programmatic open here
      // would be popup-blocked). Surface a CTA that opens the just-claimed
      // design in a NEW tab on click (user gesture). Reuses the crafted
      // guest-carry URL (handles empty fileLink / TEARAWAY correctly).
      setPostSignupUrl(url);
      setIsPostSignupLoading(false);
    };
    window.addEventListener("guest-signup-complete", handler as EventListener);
    return () => window.removeEventListener("guest-signup-complete", handler as EventListener);
  }, [isPublicBuilder, countryCode, format, editorInstance, designId]);

  // Inject guest marketing placeholders the first time a guest opens this
  // Guest gate for the Comments feature. CommentsToolbarButton fires
  // this event when a not-logged-in user clicks the comments tool in
  // the bottom panel; we open the FeatureModal teaser (`comments`
  // type) which leads into the signup flow. The button itself avoids
  // prop-drilling for the auth check — sending an event keeps the
  // wiring local.
  React.useEffect(() => {
    if (!isGuest) return;
    const handler = () => setFeatureModalType("comments");
    window.addEventListener("guest-comments-blocked", handler);
    return () => window.removeEventListener("guest-comments-blocked", handler);
  }, [isGuest]);

  // room. Polls briefly while the format shapes (front/back) get created
  // by useMultiplayerState, then drops two `customImage` shapes over them.
  // Skipped on subsequent loads (localStorage marker keyed by pathname).
  React.useEffect(() => {
    if (!isGuest || !editorInstance) return;
    const roomKey = window.location.pathname;
    let cancelled = false;
    let attempts = 0;
    const tick = () => {
      if (cancelled || attempts > 40) return;
      attempts += 1;
      const result = injectGuestPlaceholders(editorInstance, roomKey);
      if (result === "shapes-not-ready") {
        setTimeout(tick, 250);
      }
    };
    tick();
    return () => {
      cancelled = true;
    };
  }, [editorInstance, isGuest]);

  const state = app.useStore();

  const { document, settings, appState, room } = state;

  const page = document.pages[appState.currentPageId];
  const pageState = document.pageStates[page.id];
  const { selectedIds } = pageState;

  const isHideBoundsShape =
    selectedIds.length === 1 &&
    page.shapes[selectedIds[0]] &&
    (() => {
      try {
        const shapeUtil = TLDR.getShapeUtil(page.shapes[selectedIds[0]].type);
        return shapeUtil && shapeUtil.hideBounds;
      } catch (error) {
        return false;
      }
    })();

  const isHideResizeHandlesShape =
    selectedIds.length === 1 &&
    page.shapes[selectedIds[0]] &&
    (() => {
      try {
        const shapeUtil = TLDR.getShapeUtil(page.shapes[selectedIds[0]].type);
        return shapeUtil && shapeUtil.hideResizeHandles;
      } catch (error) {
        return false;
      }
    })();

  // Custom rendering meta, with dark mode for shapes
  const meta = React.useMemo(() => {
    return { isDarkMode: settings.isDarkMode };
  }, [settings.isDarkMode]);

  // Custom theme, based on darkmode
  const theme = React.useMemo(() => {
    if (settings.isDarkMode) {
      return {
        brushFill: "rgba(180, 180, 180, .05)",
        brushStroke: "rgba(180, 180, 180, .25)",
        selected: "rgba(38, 150, 255, 1.000)",
        selectFill: "rgba(38, 150, 255, 0.05)",
        background: "#212529",
        foreground: "#49555f",
      };
    }

    return {
      background: "#d9d9d9",
    };
  }, [settings.isDarkMode]);

  const isInSession = app.session !== undefined;

  const isClient = authorization.isClient();

  const [isExporting, setIsExporting] = React.useState(false);
  const [isOpenPopup, setIsOpenPopup] = React.useState(false);
  const [shapesAfterRender, setShapesAfterRender] = React.useState<any>(null);
  const [qrCodeLinkAfterRender, setQrCodeLinkAfterRender] = React.useState<string | undefined>(undefined);
  const [isTemplateModalOpen, setIsTemplateModalOpen] = React.useState(false);
  const [isDebugMode, setIsDebugMode] = React.useState(false);
  const [isCustomFontManagerOpen, setIsCustomFontManagerOpen] = React.useState(false);
  const [showAddressBoxWarning, setShowAddressBoxWarning] = React.useState(false);
  const [allowNavigation, setAllowNavigation] = React.useState(false);
  const [pendingLocation, setPendingLocation] = React.useState<any>(null);
  const history = useHistory();

  const onDone = React.useCallback(async () => {
    const isEddm = channel === CAMPAIGN_ENUM_TYPES.DIRECTMAIL;
    const isAdm = subtype === CAMPAIGN_SUBTYPES_ENUM.ADM;

    if (isAdm) {
      history.push(generatePath(ADM_ROUTING.ADM_CAMPAIGN_BUILDER, { campaignId, clientId, step: ADM_STEP.SUBMIT }));
    } else if (isEddm) {
      // Navigate back to Flyer page (Design + Tracking combined)
      history.push(generatePath(EDDM_ROUTING.EDDM_FLYER, { campaignId, clientId }));
    } else {
      // H2H/D2D — back to the unified builder (legacy details route is gone)
      history.push(generatePath(ROUTES.CAMPAIGN_BUILDER, { campaignId, clientId }));
    }
  }, [history, campaignId, clientId, subtype]);

  const [isBlocked, setIsBlocked] = React.useState<boolean>(false);

  // Template management hook
  const {
    updateDesign,
    createDesignTemplate,
    deleteTemplate,
    loading: designManagementLoading,
    designs,
  } = useDesignManagement({ clientId: clientId?.toString() || "" });

  const currentDesign = React.useMemo(() => {
    if (designId && designs.length > 0) {
      return designs.find((design) => design.id === designId) || null;
    }
    return null;
  }, [designId, designs]);

  // Push design context into the comments store so comment-mention emails can
  // include the design name + a deep link without prop drilling.
  const setCommentsDesignContext = useCommentsStore((s) => s.setDesignContext);
  React.useEffect(() => {
    const designUrl =
      typeof window !== "undefined" && designId
        ? `${window.location.origin}${window.location.pathname}${window.location.search}`
        : null;
    setCommentsDesignContext({
      designId: designId ?? null,
      designName: currentDesign?.designName || null,
      designUrl,
    });
  }, [designId, currentDesign?.designName, setCommentsDesignContext]);

  const effectiveFormat = format || flyerType;
  const isUspsCompliantFormat = React.useMemo(() => {
    if (!effectiveFormat) {
      return false;
    }
    return USPS_COMPLIANT_FORMATS.has(effectiveFormat);
  }, [effectiveFormat]);

  const hasAddressBox = Boolean(isAddressBoxVisible || currentDesign?.addressBox);
  const shouldBlockNext = isUspsCompliantFormat && !hasAddressBox;
  const addressBoxRequiredMessage =
    "Address box is required for USPS-compliant formats. Please add it before continuing.";

  const { isUploading: isPdfUploading } = usePDFUpload();

  // Enhanced save function that preserves user camera state
  // isManualSave: true for manual saves (button clicks), false for auto-saves
  // Auto-saves skip global state updates to prevent editor re-mounts
  const generateAndSaveDesign = async (isManualSave = false) => {
    // Skip save/export while PDF import from URL is in progress to avoid broken images
    if (isPdfUploading) return;
    try {
      const htmlContent = await simpleHtmlExport({
        designId,
        campaignId,
        format,
        returnHtml: true,
        editor: app, // Pass TldrawApp instance for camera control
        skipCameraAdjustment: !isManualSave, // Don't adjust camera during auto-saves
        keepCameraPosition: isManualSave, // Keep camera centered after manual saves
      });

      // Get the latest QR link value from any QR input field that might be pending
      const qrInputElement = window.document.querySelector(".qr-code-input input") as HTMLInputElement;
      const latestQrCodeLink = qrInputElement?.value || qrCodeLink;

      // Normalize QR code link (add protocol if missing)
      const normalizedQrLink = latestQrCodeLink?.length
        ? latestQrCodeLink?.startsWith("https://") || latestQrCodeLink?.startsWith("http://")
          ? latestQrCodeLink
          : `https://${latestQrCodeLink}`
        : qrCodeLink;

      // ✅ ALWAYS save to backend (critical for data persistence)
      // Persist filename + format alongside htmlContent — without them the
      // design-management list refreshes from server-stale values and the
      // reopen-URL builder falls into its empty-string fallback (iframe
      // hangs with no loader). See `DesignEditor.js` for the reopen logic.
      await Promise.all([
        updateDesign({
          designId: Number(designId),
          design: {
            htmlContent: htmlContent as string,
            designSource: DesignSource.FLYER_BUILDER,
            ...(currentDesign?.designName && {
              filename: currentDesign.designName,
            }),
            ...(effectiveFormat && { format: effectiveFormat }),
          },
        }),
        ...(campaignId
          ? [
              updateCampaignExtraData({
                campaignId: campaignId,
                qrCodeLink: normalizedQrLink,
              }),
            ]
          : []),
      ]);

      // ⚠️ ONLY update global state on manual saves
      // Auto-saves skip this to prevent editor re-mounts that clear undo/redo history
      if (isManualSave && campaignId) {
        // Update store state to ensure consistency
        updateCampaign({ qrCodeLink: normalizedQrLink });

        // Trigger a campaign data refresh to ensure store is synced with backend
        // This helps prevent QR links from disappearing on page refresh
        try {
          const refreshedCampaignData = await getCampaign(campaignId, clientId);
          if (refreshedCampaignData?.qrCodeLink) {
            updateCampaign({ qrCodeLink: refreshedCampaignData.qrCodeLink });
          }
        } catch (error) {
          console.warn("Could not refresh campaign data after save:", error);
        }
      }
    } catch (error) {
      console.error("Error in generateAndSaveDesign:", error);
    }
  };

  const handlePublicBuilderRedirect = async () => {
    // Check if current format requires addressbox
    const isCompliantFormat = isADMFormat(flyerType) || isEDDMFormat(flyerType);

    if (isCompliantFormat && editorInstance) {
      // Check if addressbox exists
      const addressBox = editorInstance.getShape("shape:addressBox" as TLShapeId);
      const hasAddressBox = Boolean(addressBox && addressBox.type === "customAddressBox");

      if (!hasAddressBox) {
        // Show warning modal
        setShowAddressBoxWarning(true);
        return; // Stop here, don't navigate yet
      }
    }

    // Original logic continues if addressbox check passes
    // Show loading state
    setIsExporting(true);

    try {
      // Save design before navigating back (manual save = true)
      await generateAndSaveDesign(true);

      // Notify parent iframe that we're done - parent handles navigation
      window.parent.postMessage(
        {
          type: "save",
          data: {
            designId: designId,
            designName: currentDesign?.designName,
            format: flyerType,
          },
        },
        "*"
      );
    } catch (error) {
      console.error("Failed to save before going back:", error);
      runSnackBar({
        type: "error",
        msg: "Failed to save design",
        vertical: "top",
        horizontal: "right",
      });
    } finally {
      setIsExporting(false);
    }
  };

  const handleConfirmAndLeave = async () => {
    setShowAddressBoxWarning(false);

    // If there's a pending location, allow navigation and go there
    if (pendingLocation) {
      setAllowNavigation(true);
      // Use setTimeout to ensure state update happens before navigation
      setTimeout(() => {
        history.push(pendingLocation.pathname + pendingLocation.search);
      }, 0);
      return;
    }

    // Proceed with navigation without addressbox
    setIsExporting(true);

    try {
      await generateAndSaveDesign(true);

      // Check if we're in iframe mode or normal mode
      if (isPublicBuilder) {
        // Iframe mode: notify parent
        window.parent.postMessage(
          {
            type: "save",
            data: {
              designId: designId,
              designName: currentDesign?.designName,
              format: flyerType,
            },
          },
          "*"
        );
      } else {
        // Normal mode: navigate back
        onBack();
      }
    } catch (error) {
      runSnackBar({
        type: "error",
        msg: "Failed to save design",
        vertical: "top",
        horizontal: "right",
      });
    } finally {
      setIsExporting(false);
    }
  };

  const handleAddAddressBoxFromModal = async () => {
    setShowAddressBoxWarning(false);
    setPendingLocation(null); // Clear pending navigation

    if (!editorInstance) {
      return;
    }

    // Get the current page bounds and center
    const pageBounds = editorInstance.getCurrentPageBounds();
    if (!pageBounds) {
      return;
    }

    const centerX = (pageBounds.minX + pageBounds.maxX) / 2;
    const centerY = (pageBounds.minY + pageBounds.maxY) / 2;
    const displayWidth = pageBounds.width;
    const displayHeight = pageBounds.height;

    const isPortrait = editorInstance.getCurrentPage()?.meta?.orientation === "portrait";

    // Determine which type of addressbox to add based on format
    if (isADMFormat(flyerType)) {
      shapesAddressBox(
        editorInstance,
        isPortrait,
        centerX,
        centerY,
        displayWidth,
        displayHeight,
        "", // frontBgAssetId
        20, // safetyZonePx
        3, // bleedsZoneMM
        "", // logo
        "", // qrCode
        false // existSnapshot
      );
    } else if (isEDDMFormat(flyerType)) {
      shapesAddressBoxEddm(
        editorInstance,
        isPortrait,
        centerX,
        centerY,
        displayWidth,
        displayHeight,
        "", // frontBgAssetId
        20, // safetyZonePx
        3, // bleedsZoneMM
        "", // logo
        "", // qrCode
        false // existSnapshot
      );
    }

    // Update the design in the database to reflect that addressBox is now true
    if (designId) {
      try {
        await updateDesign({
          designId: Number(designId),
          design: {
            addressBox: true,
          },
        });
      } catch (error) {
        console.error("[AddressBox] Failed to update design:", error);
      }
    }
  };

  // Block navigation when USPS format without address box
  React.useEffect(() => {
    if (allowNavigation) {
      // Reset the flag after navigation is allowed
      setAllowNavigation(false);
      return;
    }

    const unblock = history.block((location, action) => {
      // Get current path without query params
      const currentPath = history.location.pathname;
      const targetPath = location.pathname;

      // Check for both normal builder path and iframe path (design-management/design/)
      const isBuilderPath = (path: string) =>
        path.includes("/builder/design/") || path.includes("/design-management/design/");

      const currentIsBuilder = isBuilderPath(currentPath);
      const targetIsBuilder = isBuilderPath(targetPath);

      // If staying within builder (both paths are builder paths), allow navigation freely
      // This covers format changes, query param updates, etc.
      if (currentIsBuilder && targetIsBuilder) {
        return undefined; // Allow navigation (staying in builder)
      }

      // Only check for address box if user is LEAVING the builder
      if (currentIsBuilder && !targetIsBuilder) {
        // Check if format is USPS compliant and has no address box
        const isCompliantFormat = isADMFormat(flyerType) || isEDDMFormat(flyerType);

        if (isCompliantFormat && editorInstance) {
          const addressBox = editorInstance.getShape("shape:addressBox" as TLShapeId);
          const hasAddressBox = Boolean(addressBox && addressBox.type === "customAddressBox");

          if (!hasAddressBox) {
            // Block navigation and show modal
            setPendingLocation(location);
            setShowAddressBoxWarning(true);
            return false; // Block the navigation
          }
        }
      }

      // Allow navigation in all other cases
      return undefined;
    });

    return () => {
      unblock();
    };
  }, [history, flyerType, editorInstance, allowNavigation]);

  // Template operation wrappers
  const handleSaveTemplate = async (input: {
    name: string;
    description?: string;
    isPublic: boolean;
    promoOffer?: string[];
    industry?: string[];
    useCase?: string[];
    uspsCompliant?: boolean;
    thumbnail?: string;
  }) => {
    const { name, description, isPublic, promoOffer, industry, useCase, uspsCompliant } = input;

    try {
      // Validate required fields
      if (!name || !name.trim()) {
        throw new Error("Template name is required");
      }

      if (!designId) {
        throw new Error("No room ID available");
      }

      // Show loading state
      runSnackBar({
        type: "info",
        msg: "Saving template...",
        vertical: "top",
        horizontal: "right",
      });

      // Get thumbnail (use a placeholder or generate from current design)
      const htmlContent = await simpleHtmlExport({
        designId,
        campaignId,
        format,
        returnHtml: true,
        editor: app, // Pass TldrawApp instance for camera control
      });

      if (!htmlContent) {
        throw new Error("Failed to generate design content");
      }

      // Calculate dimensions in millimeters for thumbnail generation
      const customDimensions = getFormatDimensionsWithFallback(format ?? "");

      const thumbnail = await generateFileFromService({
        htmlString: htmlContent as string,
        fileType: "JPEG",
        quality: 50,
        includeBleedsAndCropMarks: false,
        flattenPDF: true,
        compressionLevel: "high",
        customDimensions, // Send precise dimensions in millimeters
      });

      if (!thumbnail || !thumbnail.s3Url) {
        throw new Error("Failed to generate template thumbnail");
      }

      // Save template with proper error handling
      const savedTemplate = await createDesignTemplate({
        roomId: designId,
        orientation: app.document.orientation,
        format: format ?? "",
        thumbnail: thumbnail.s3Url,
        name: name.trim(),
        description: description?.trim(),
        isPublic,
        promoOffer: promoOffer?.join(",") || undefined,
        industry: industry?.join(",") || undefined,
        useCase: useCase?.join(",") || undefined,
        uspsCompliant,
      });

      // Verify template was actually saved
      if (!savedTemplate || !savedTemplate.id) {
        throw new Error("Template creation failed - no ID returned");
      }

      runSnackBar({
        type: "success",
        msg: `Template "${name.trim()}" saved successfully!`,
        vertical: "top",
        horizontal: "right",
      });
    } catch (error) {
      console.error("Template save error:", error);

      let errorMessage = "Error saving template";
      if (error instanceof Error) {
        errorMessage = error.message;
      } else if (typeof error === "string") {
        errorMessage = error;
      }

      // Check for specific S3 or network errors
      if (errorMessage.includes("NetworkError") || errorMessage.includes("S3")) {
        errorMessage = "Failed to save template - please check your connection and try again";
      } else if (errorMessage.includes("Unauthorized") || errorMessage.includes("403")) {
        errorMessage = "You don't have permission to save templates";
      }

      runSnackBar({
        type: "error",
        msg: errorMessage,
        vertical: "top",
        horizontal: "right",
      });
    }
  };

  const handleApplyTemplate = async (template: DesignTemplate) => {
    try {
      if (template.roomId) {
        // Load the template from the room ID
        // This would typically involve loading the room data from Liveblocks
        // For now, we'll just show a success message
        // TODO: Implement room loading logic here
        // This might involve:
        // 1. Loading the room data from Liveblocks
        // 2. Applying the room data to the current Tldraw instance
        // 3. Updating the current room with the template data
      }

      runSnackBar({
        type: "success",
        msg: "Template applied successfully!",
        vertical: "top",
        horizontal: "right",
      });
    } catch (error) {
      runSnackBar({
        type: "error",
        msg: `Error applying template: ${error}`,
        vertical: "top",
        horizontal: "right",
      });
    }
  };

  const handleDeleteTemplate = async (templateId: string) => {
    try {
      await deleteTemplate(templateId);
      runSnackBar({
        type: "success",
        msg: "Template deleted successfully!",
        vertical: "top",
        horizontal: "right",
      });
    } catch (error) {
      runSnackBar({
        type: "error",
        msg: `Error deleting template: ${error}`,
        vertical: "top",
        horizontal: "right",
      });
    }
  };

  React.useEffect(() => {
    setShapesAfterRender((prev: any) => {
      if (!prev && Object.keys(page.shapes).length) {
        return page.shapes;
      } else {
        return prev;
      }
    });
  }, [page.shapes]);

  React.useEffect(() => {
    // @ts-ignore
    setQrCodeLinkAfterRender((prev: string | undefined) => {
      if (!prev && isValidUrl(qrCodeLink)) {
        return qrCodeLink;
      } else {
        return prev;
      }
    });
  }, [qrCodeLink]);

  const isChanged = () => {
    if (page.shapes && JSON.stringify(page.shapes) !== JSON.stringify(shapesAfterRender)) {
      return true;
    } else {
      if (isValidUrl(qrCodeLink)) {
        if (!isValidUrl(qrCodeLinkAfterRender)) {
          return true;
        } else {
          return qrCodeLink !== qrCodeLinkAfterRender;
        }
      } else {
        if (isValidUrl(qrCodeLinkAfterRender)) {
          return true;
        } else {
          return false;
        }
      }
    }
  };

  const onPdfExport = React.useCallback(async () => {
    //TODO Implement On Print
    alert("This feature in development");
  }, []);
  const runSnackBar = React.useContext(SnackBarContext);

  const onBack = () => {
    const isAdm = subtype === CAMPAIGN_SUBTYPES_ENUM.ADM;
    const isEddm = channel === CAMPAIGN_ENUM_TYPES.DIRECTMAIL;
    if (isAdm) {
      history.push(generatePath(ADM_ROUTING.ADM_CAMPAIGN_BUILDER, { campaignId, clientId, step: ADM_STEP.SEGMENTS }));
    } else if (isEddm) {
      history.push(generatePath(EDDM_ROUTING.EDDM_FLYER, { campaignId, clientId }));
    } else {
      // H2H/D2D — back to the unified builder (legacy details route is gone)
      history.push(generatePath(ROUTES.CAMPAIGN_BUILDER, { campaignId, clientId }));
    }
  };

  const handleSave = async ({ withBack = false, format }: { withBack?: boolean; format?: string }) => {
    try {
      if (!app.document || !app.document.pages || Object.keys(app.document.pages).length === 0) {
        throw new Error("No document content to save");
      }
      const htmlContent = await simpleHtmlExport({
        designId,
        campaignId,
        format: format || flyerType, // Use default format if flyerType is not available
        returnHtml: true,
        editor: app, // Pass TldrawApp instance for camera control
      });

      if (!htmlContent) {
        throw new Error("Failed to generate HTML content");
      }

      // Get the latest QR link value from any QR input field that might be pending
      const qrInputElement = window.document.querySelector(".qr-code-input input") as HTMLInputElement;
      const latestQrCodeLink = qrInputElement?.value || qrCodeLink;

      // Normalize QR code link (add protocol if missing)
      const normalizedQrLink = latestQrCodeLink?.length
        ? latestQrCodeLink?.startsWith("https://") || latestQrCodeLink?.startsWith("http://")
          ? latestQrCodeLink
          : `https://${latestQrCodeLink}`
        : qrCodeLink;

      // Save both design content and QR code link
      await Promise.all([
        updateDesign({
          designId: parseInt(designId),
          design: {
            htmlContent,
            format: format, // Use default format if flyerType is not available
            designSource: DesignSource.FLYER_BUILDER,
          },
        }),
        updateCampaignExtraData({
          campaignId: campaignId,
          qrCodeLink: normalizedQrLink,
        }),
      ]);

      // Update store state to ensure consistency
      updateCampaign({ qrCodeLink: normalizedQrLink });

      // Trigger a campaign data refresh to ensure store is synced with backend
      // This helps prevent QR links from disappearing on page refresh
      try {
        const refreshedCampaignData = await getCampaign(campaignId, clientId);
        if (refreshedCampaignData?.qrCodeLink) {
          updateCampaign({ qrCodeLink: refreshedCampaignData.qrCodeLink });
        }
      } catch (error) {
        console.warn("Could not refresh campaign data after save:", error);
      }

      if (withBack) {
        onBack();
      }
    } catch (error) {
      console.error("Save error:", error);
      // Show user-friendly error message
      const errorMessage = error instanceof Error ? error.message : "Unknown error occurred";
      alert(`Save failed: ${errorMessage}`);
    }
  };

  const handleFileDrop = async (file: React.DragEvent<Element>) => {
    try {
      await app.onDrop(file);
    } catch (error) {
      runSnackBar({
        type: "error",
        msg: `Error while uploading the file: ${error}`,
        vertical: "bottom",
        horizontal: "right",
      });
    }
  };

  const handleNext = async () => {
    setIsBlocked(true);

    if (shouldBlockNext) {
      setIsBlocked(false);
      runSnackBar({
        type: "error",
        msg: addressBoxRequiredMessage,
        vertical: "top",
        horizontal: "right",
      });
      return;
    }

    const { internalStatus, flyerType, flyerWeight } = await getCampaign(campaignId);
    if (internalStatus !== CAMPAIGN_INTERNAL_STATUSES.DRAFT) {
      return runSnackBar({
        type: "error",
        msg: "Campaign already submitted.",
        vertical: "top",
        horizontal: "right",
      });
    }

    setIsExporting(true);

    // Get the latest QR link value from any QR input field that might be pending
    const qrInputElement = window.document.querySelector(".qr-code-input input") as HTMLInputElement;
    const latestQrCodeLink = qrInputElement?.value || qrCodeLink;

    // Normalize QR code link (add protocol if missing)
    const normalizedQrLink = latestQrCodeLink?.length
      ? latestQrCodeLink?.startsWith("https://") || latestQrCodeLink?.startsWith("http://")
        ? latestQrCodeLink
        : `https://${latestQrCodeLink}`
      : qrCodeLink;

    const isNeedUpdateLastActiveStep = checkIsNeedUpdateLastActiveStepState({
      stateLastActiveStep: lastActiveStep,
      newLastActiveStep: "design",
      channel: channel,
    });

    const payloadUpdateExtraData = {
      campaignId: campaignId,
      qrCodeLink: normalizedQrLink,
      lastActiveStep: lastActiveStep,
    };

    if (isNeedUpdateLastActiveStep) {
      payloadUpdateExtraData.lastActiveStep = "design";
    }

    await updateCampaignExtraData(payloadUpdateExtraData);

    saveFlyerBuilderStates?.();

    await updateDesign({
      designId: Number(designId),
      design: {
        isUploaded: true,
      },
    });

    updateErrors({ notExistDesignFile: false });

    const gtagOptions: GtagOptions = {
      event: "ss_design_submitted",
      client_id: clientId?.toString(),
      user_id: userId,
      campaign_id: campaignId,
      flyer_format: flyerType,
      flyer_weight: flyerWeight,
      flyer_submitted_type: "design",
      nr_of_elements_created: Object.keys(app.state.document.assets).length,
    };
    gtagWrapper(gtagOptions);

    // Use full export for final submission to ensure all fonts and assets are properly embedded
    // Pass true to indicate this is a manual save (updates global state)
    await generateAndSaveDesign(true);

    // Final campaign data refresh to ensure Campaign Details page displays correct QR link
    try {
      const finalCampaignData = await getCampaign(campaignId, clientId);
      if (finalCampaignData?.qrCodeLink !== undefined) {
        updateCampaign({
          qrCodeLink: finalCampaignData.qrCodeLink,
          lastActiveStep: payloadUpdateExtraData.lastActiveStep,
        });
      }
    } catch (error) {
      console.warn("Could not refresh campaign data before navigation:", error);
      // Still update store with what we know
      updateCampaign({
        lastActiveStep: payloadUpdateExtraData.lastActiveStep,
        qrCodeLink: normalizedQrLink,
      });
    }

    await onDone();

    setIsBlocked(false);
  };

  const homeUrl = `${CONFIG.PLATFORM_BASE_URL}${
    clientId && isClient ? `/dashboard/client-campaigns/${clientId}/campaign` : ""
  }`;

  const [isExportDropdownOpen, setIsExportDropdownOpen] = React.useState(false);
  const exportDropdownRef = useRef<HTMLDivElement>(null);

  // Handle click outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (exportDropdownRef.current && !exportDropdownRef.current.contains(event.target as Node)) {
        setIsExportDropdownOpen(false);
      }
    };

    if (isExportDropdownOpen) {
      window.document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      window.document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isExportDropdownOpen]);

  const handleDesignNameSave = async (newName: string) => {
    if (designId && newName.trim()) {
      try {
        await updateDesign({
          designId: Number(designId),
          design: {
            filename: newName.trim(),
          },
        });
      } catch (error) {
        console.error("Error updating design filename:", error);
      }
    }
  };
  const mainNavActions = React.useMemo(
    () => {
      const isValid = true; //isValidUrl(qrCodeLink);
      const isOnCanvas = true; //app.isQrCodesOnCanvas();
      const actions: any[] = [];
      if (isPublicBuilder && !isGuest) {
        actions.push({
          component: (
            <DesignNameInput
              initialValue={currentDesign?.designName || "Untitled Design"}
              onSave={handleDesignNameSave}
            />
          ),
          isActive: true,
          cypressId: "HeaderButton_DesignName",
        });
      }

      actions.push({
        component: isGuest ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "5.03px",
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              style={{ width: 20, height: 20, aspectRatio: "1/1" }}
            >
              <g clipPath="url(#clip0_9757_84701)">
                <path
                  d="M10.834 10.832H6.66732C6.4463 10.832 6.23434 10.9198 6.07806 11.0761C5.92178 11.2324 5.83398 11.4444 5.83398 11.6654V17.4987"
                  stroke="#F96B06"
                  strokeWidth="1.25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M11.666 6.66797H12.4993"
                  stroke="#F96B06"
                  strokeWidth="1.25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M14.166 17.5013V14.168"
                  stroke="#F96B06"
                  strokeWidth="1.25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M1.66602 1.66797L18.3327 18.3346"
                  stroke="#F96B06"
                  strokeWidth="1.25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M17.0083 17.0089C16.6972 17.3218 16.2746 17.4987 15.8333 17.5005H4.16667C3.72464 17.5005 3.30072 17.3249 2.98816 17.0124C2.67559 16.6998 2.5 16.2759 2.5 15.8339V4.16719C2.50186 3.72587 2.67868 3.30331 2.99167 2.99219"
                  stroke="#F96B06"
                  strokeWidth="1.25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M7.5 2.5H12.6667C13.1063 2.50626 13.5256 2.68598 13.8333 3L17 6.16667C17.314 6.47438 17.4937 6.89372 17.5 7.33333V12.5"
                  stroke="#F96B06"
                  strokeWidth="1.25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_9757_84701">
                  <rect width="20" height="20" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <span
              style={{
                color: "#F96B06",
                textAlign: "center",
                fontFeatureSettings: "'liga' off, 'clig' off",
                fontFamily: '"Inter"',
                fontSize: 12,
                fontStyle: "normal",
                fontWeight: 400,
                lineHeight: "15px",
              }}
            >
              Guest Session
            </span>
          </div>
        ) : (
          <ChangesSaved tlStore={tlStore} onSave={generateAndSaveDesign} />
        ),
        isActive: true,
        cypressId: isGuest ? "HeaderButton_GuestSession" : "HeaderButton_ChangesSaved",
      });

      actions.push({
        component: isGuest ? (
          <div
            onClick={() => setIsSignupModalOpen(true)}
            style={{
              display: "flex",
              minHeight: 40,
              maxHeight: 40,
              padding: "0 24px",
              justifyContent: "center",
              alignItems: "center",
              gap: 8,
              borderRadius: 12,
              background: "#EE4360",
              cursor: "pointer",
            }}
          >
            <span
              style={{
                color: "#FFF",
                textAlign: "center",
                fontFeatureSettings: "'liga' off, 'clig' off",
                fontFamily: '"Inter"',
                fontSize: 16,
                fontStyle: "normal",
                fontWeight: 700,
                lineHeight: "120%",
              }}
            >
              Sign Up to Save & Export
            </span>
          </div>
        ) : (
          <ExportButton format={format ?? ""} editor={app} />
        ),
        isActive: true,
        cypressId: isGuest ? "HeaderButton_GuestSignUp" : "HeaderButton_ExportDesignPDF",
      });

      if (isGuest) {
        // Guests get a single Back button that points to the marketing
        // site. Wired through `LeaveWarningModal` because leaving
        // discards the in-progress design — we want one explicit
        // confirmation before we actually navigate away. Destination
        // is `oppizi.com` today; a later iteration will fall back to
        // the previous page when there is one (referrer-based) and
        // keep `oppizi.com` as the default for cold opens.
        actions.push({
          component: (
            <div
              className="flex items-center cursor-pointer p-2 hover:bg-gray-100 rounded absolute left-0"
              onClick={() => setShowGuestLeaveWarning(true)}
              data-cypress-id="backBtn"
            >
              <img src={backIcon} alt="back" style={{ marginRight: 6 }} />
              <span>Back</span>
            </div>
          ),
          variant: "active",
          cypressId: "backBtn",
          isActive: true,
          hideArrow: true,
        } as any);
      } else if (isPublicBuilder && !workflowUuid) {
        actions.push({
          component: isFromGuestCarry ? (
            // Post-guest-signup variant: same look as the regular Back
            // button (back-arrow icon + "Back" text) but with a small
            // chevron-down to the left signalling "this opens a menu
            // of options" — the regular Back is a single
            // destination, this one isn't. Clicking opens a Menu with
            // the two reasonable post-signup destinations: the
            // marketing site (oppizi.com) and the platform home
            // (`CONFIG.PLATFORM_BASE_URL`). The guest had no
            // pre-existing landing page to return to, so we offer the
            // two answers rather than the iframe parent postMessage
            // flow used elsewhere.
            <>
              <div
                className="flex items-center cursor-pointer p-2 hover:bg-gray-100 rounded absolute left-0"
                onClick={(e) => setBackMenuAnchor(e.currentTarget)}
                data-cypress-id="backBtn"
              >
                <img src={backIcon} alt="back" style={{ marginRight: 6 }} />
                <span>Back</span>
                {/* Chevron-down to the right of the "Back" label: pure
                    visual cue that this is a menu trigger, not a
                    single-destination back action. Rotates 180° when
                    the menu is open. */}
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  style={{
                    marginLeft: 6,
                    transition: "transform 150ms ease",
                    transform: backMenuAnchor ? "rotate(180deg)" : "none",
                  }}
                >
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </div>
              <Menu
                anchorEl={backMenuAnchor}
                open={Boolean(backMenuAnchor)}
                onClose={() => setBackMenuAnchor(null)}
                getContentAnchorEl={null}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                transformOrigin={{ vertical: "top", horizontal: "left" }}
                PaperProps={{
                  style: { borderRadius: 8, marginTop: 4 },
                }}
                MenuListProps={{ style: { padding: 4 } }}
              >
                {/* `!` prefixes force the tailwind hover bg to win
                    over MUI's default action.hover from theme; the
                    `#E2E2FC` matches the rest of the builder's hover
                    treatment (AlignActions, TextParameters, etc.).
                    `gap-2` aligns the leading icon with the label. */}
                <MenuItem
                  className="!rounded-[6px] hover:!bg-[#E2E2FC] !gap-2"
                  onClick={() => {
                    setBackMenuAnchor(null);
                    window.location.href = "https://oppizi.com/";
                  }}
                >
                  {/* Globe icon — represents the public marketing
                      website. Sized + stroked to mirror the sidebar
                      home icon so the two list items read as a pair. */}
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 22 22"
                    fill="none"
                    stroke="#2D264B"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle cx="11" cy="11" r="9" />
                    <path d="M2 11h18" />
                    <path d="M11 2c2.5 2.7 3.9 5.8 3.9 9s-1.4 6.3-3.9 9c-2.5-2.7-3.9-5.8-3.9-9s1.4-6.3 3.9-9z" />
                  </svg>
                  oppizi.com
                </MenuItem>
                <MenuItem
                  className="!rounded-[6px] hover:!bg-[#E2E2FC] !gap-2"
                  onClick={() => {
                    setBackMenuAnchor(null);
                    window.location.href = CONFIG.PLATFORM_BASE_URL;
                  }}
                >
                  {/* Same path as `SidebarHomeIcon` (the icon the
                      platform's left sidebar uses for Home) — inlined
                      here at 18×18 so it pairs visually with the
                      globe icon above. Reusing the same glyph keeps
                      the visual association: "this takes you back to
                      the dashboard you'd normally see in the
                      sidebar". The component itself hardcodes 22×22
                      which we can't override via CSS easily, so we
                      copy the path. */}
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 22 22"
                    fill="none"
                    stroke="#2D264B"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M8.15722 19.7714V16.7047C8.1572 15.9246 8.79312 15.2908 9.58101 15.2856H12.4671C13.2587 15.2856 13.9005 15.9209 13.9005 16.7047V19.7809C13.9003 20.4432 14.4343 20.9845 15.103 21H17.0271C18.9451 21 20.5 19.4607 20.5 17.5618V8.83784C20.4898 8.09083 20.1355 7.38935 19.538 6.93303L12.9577 1.6853C11.8049 0.771566 10.1662 0.771566 9.01342 1.6853L2.46203 6.94256C1.86226 7.39702 1.50739 8.09967 1.5 8.84736V17.5618C1.5 19.4607 3.05488 21 4.97291 21H6.89696C7.58235 21 8.13797 20.4499 8.13797 19.7714Z" />
                  </svg>
                  Oppizi OAds
                </MenuItem>
              </Menu>
            </>
          ) : (
            <div
              className="flex items-center cursor-pointer p-2 hover:bg-gray-100 rounded absolute left-0"
              onClick={handlePublicBuilderRedirect}
            >
              {isExporting ? (
                <CircularProgress size={20} style={{ color: "#64b5f6" }} />
              ) : (
                <>
                  <img src={backIcon} alt="back" style={{ marginRight: 6 }} />
                  <span>Back</span>
                </>
              )}
            </div>
          ),
          variant: "active",
          cypressId: "backBtn",
          isActive: true,
          hideArrow: true,
        } as any);
        // TODO: Add template save button when we have template feature available to admins
        //
        // actions.push({
        //   component: (
        //     <LightTooltip title="Save template" placement="bottom" className="cursor-pointer">
        //       <div
        //         className={"w-10 h-10 flex items-center justify-center p-2 hover:bg-gray-100 rounded-full"}
        //         onClick={() => setIsTemplateModalOpen(true)}
        //       >
        //         <TemplateIcon stroke="#1D2943" />
        //       </div>
        //     </LightTooltip>
        //   ),
        //   variant: "active",
        //   cypressId: "Save template",
        //   hideArrow: true,
        //   isActive: true,
        // } as any);
      } else {
        const nextButtonTitle = shouldBlockNext ? addressBoxRequiredMessage : undefined;
        const nextButtonClassName = cn(styles.nextButton, {
          [styles.nextButtonDisabled]: shouldBlockNext,
        });

        actions.push({
          title: (
            <div className={nextButtonClassName} title={nextButtonTitle}>
              {isExporting ? <CircularProgress className={styles.progress} size={20} /> : ""} Next
            </div>
          ),
          variant: "active",
          cypressId: "goToNextStepBtn",
          isActive: true,
          isValidUrl: isValid,
          isQrCodeOnCanvas: isOnCanvas,
          action: async () => {
            if (shouldBlockNext) {
              runSnackBar({
                type: "error",
                msg: addressBoxRequiredMessage,
                vertical: "top",
                horizontal: "right",
              });
              return;
            }
            if (workflowUuid) {
              await handlePublicBuilderRedirect();
            } else {
              await handleNext();
            }
          },
        } as any);
      }
      return actions;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      onDone,
      onPdfExport,
      app.shapes,
      app.document.orientation,
      app.state.document.assets?.qrCode?.src,
      homeUrl,
      currentDesign,
      handlePublicBuilderRedirect,
      workflowUuid,
      shouldBlockNext,
      runSnackBar,
      addressBoxRequiredMessage,
      isFromGuestCarry,
      backMenuAnchor,
    ]
  );

  const onSave = async () => {
    await handleSave({ withBack: true, format });
  };

  const onSkip = () => {
    app.restoreToOriginal();

    /**
     * in the above function, we used 'debouncedOnChange' function of ;useMultiplayerState' hook.
     * so 'onChangePage' function will be entered callback queue and will be executed after 500ms
     * We should execute 'onBack' after the 'onChangePage' function, so we need to insert 'onBack' function into the callback queue
     * after 'onChangePage' function
     */
    setTimeout(() => {
      onBack();
    }, 1000);
  };

  const headerActions = {
    BACK: {
      cypressId: "backToCampBuilderBtn",
      action: async () => {
        // Check if current format requires addressbox
        const isCompliantFormat = isADMFormat(flyerType) || isEDDMFormat(flyerType);

        if (isCompliantFormat && editorInstance) {
          // Check if addressbox exists
          const addressBox = editorInstance.getShape("shape:addressBox" as TLShapeId);
          const hasAddressBox = Boolean(addressBox && addressBox.type === "customAddressBox");

          if (!hasAddressBox) {
            // Show warning modal
            setShowAddressBoxWarning(true);
            return; // Stop here, don't navigate yet
          }
        }

        // Original logic continues if addressbox check passes
        // Show loading state
        setIsExporting(true);

        try {
          // Save design before navigating back (manual save = true)
          await generateAndSaveDesign(true);

          // Navigate back after successful save
          onBack();
        } catch (error) {
          console.error("Failed to save before going back:", error);
          runSnackBar({
            type: "error",
            msg: "Failed to save design",
            vertical: "top",
            horizontal: "right",
          });
        } finally {
          setIsExporting(false);
        }
      },
    },
  };

  // DefaultColorThemePalette.lightMode.black.solid = "#64b5f6";
  const [isShowCustomStylePanel, setIsShowCustomStylePanel] = React.useState(false);
  const user = useMemo(() => authorization.getUser(), [authorization]);

  // Build the cursor label the same way we build the Liveblocks userInfo
  // (see `buildLiveblocksUserPayload`): prefer real first+last name, then
  // email, and only fall back to "Guest" for unauthenticated visitors.
  // `clientName` is intentionally NOT used — it's the company name, not the
  // person's, and would render every collaborator from the same company under
  // the same label.
  const cursorDisplayName = useMemo(() => {
    if (!user) return "Guest";
    const fullName = [user.firstName, user.lastName].filter(Boolean).join(" ");
    return fullName || user.email || "Guest";
  }, [user?.firstName, user?.lastName, user?.email]);

  const [userPreferences, setUserPreferences] = useState<TLUserPreferences>({
    id: user?.id ? `user-${user.id}` : "public",
    name: cursorDisplayName,
    color: "palevioletred",
    colorScheme: "light",
  });

  // Keep the preference in sync if the authenticated user changes without a
  // full page refresh (logout → login). Without this the cursor label would
  // stay stuck on the previous session's name.
  useEffect(() => {
    setUserPreferences((prev) => (prev.name === cursorDisplayName ? prev : { ...prev, name: cursorDisplayName }));
  }, [cursorDisplayName]);

  // const store = useSyncDemo({ roomId, userInfo: userPreferences });
  const tlUser = useTldrawUser({ userPreferences, setUserPreferences });
  const [idFormat, setIdFromat] = useState("shape:front");
  // need to handle nodesList
  // The sidebar can clear the section (`null`) when a tab is closed, so
  // the type has to be wider than the initial value. Without the explicit
  // generic, `useState(SECTIONS.SETTINGS)` infers `string` and rejects
  // `null` from the guest-aware wrapper below.
  const [selectedSection, setSelectedSection] = useState<string | null>(SECTIONS.SETTINGS);

  // Guests don't get the real Brand Kit / Variables panels — clicking those
  // sidebar tabs opens the FeatureModal teaser instead. All other sections
  // pass through to the normal selectedSection state.
  const handleSidebarSectionChange = React.useCallback(
    (section: string | null) => {
      if (isGuest && section === SECTIONS.BRAND_KIT) {
        setFeatureModalType("brandkit");
        return;
      }
      if (isGuest && section === SECTIONS.VARIABLES) {
        setFeatureModalType("variables");
        return;
      }
      setSelectedSection(section);
    },
    [isGuest]
  );

  const [isShowSidebar, setIsShowSidebar] = React.useState(true);
  const [prevIsShowSidebar, setPrevIsShowSidebar] = React.useState(isShowSidebar);
  const [activeTool, setActiveTool] = useState("select"); // Track active tool

  useEffect(() => {
    const handleOpenSettings = () => {
      setSelectedSection(SECTIONS.SETTINGS);
      setIsShowSidebar(true);
    };
    window.addEventListener("openSettingsPanel", handleOpenSettings);
    return () => window.removeEventListener("openSettingsPanel", handleOpenSettings);
  }, []);

  useEffect(() => {
    const handleOpenBrandKitFonts = (e: Event) => {
      const fontName = (e as CustomEvent).detail?.fontName || "";
      setSelectedSection(SECTIONS.BRAND_KIT);
      setIsShowSidebar(true);
      // Delay so BrandFontsSection has time to mount before receiving the expand event
      setTimeout(() => {
        window.dispatchEvent(new CustomEvent("expand-brand-kit-fonts", { detail: { fontName } }));
      }, 150);
    };
    window.addEventListener("open-brand-kit-fonts", handleOpenBrandKitFonts);
    return () => window.removeEventListener("open-brand-kit-fonts", handleOpenBrandKitFonts);
  }, []);

  useEffect(() => {
    const handleToggleSidebar = () => {
      setIsShowSidebar((prev) => !prev);
    };
    window.addEventListener("toggleSidebar", handleToggleSidebar);
    return () => window.removeEventListener("toggleSidebar", handleToggleSidebar);
  }, []);

  // Persist hand tool state
  const handleToolChange = (tool: string) => {
    setActiveTool(tool);
    // Only change tool if user explicitly selects a different tool
    if (tool !== "hand" || activeTool === "hand") {
      // Update the app's tool state
      if ((window as any).tldraw && (window as any).tldraw.app) {
        (window as any).tldraw.app.selectTool(tool);
      }
    }
  };

  React.useEffect(() => {
    setPrevIsShowSidebar(isShowSidebar);
  }, [isShowSidebar]);

  // Export dropdown handlers

  const options = React.useMemo<Partial<TldrawOptions>>(
    () => ({
      createTextOnCanvasDoubleClick: false,
      maxPages: 1,
      defaultSvgPadding: 0,
      // Note: bounds property removed as it's not supported in TldrawOptions
    }),
    []
  );

  const { fonts, customFontsLoaded } = useFontsContext();

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: CONFIG.GOOGLE_API_KEY as string,
    libraries: libraries as any,
    language: "en",
    version: "3.64",
  });

  // Use refs to store dynamic props that change frequently (to avoid re-creating the component)
  const sidebarPropsRef = React.useRef({
    isLoaded,
    tlStore,
    loading,
    selectedSection,
    isShowSidebar,
  });

  // Update ref on every render (this doesn't cause re-renders)
  React.useLayoutEffect(() => {
    sidebarPropsRef.current = {
      isLoaded,
      tlStore,
      loading,
      selectedSection,
      isShowSidebar,
    };
  });

  // Create stable InFrontOfTheCanvas component (created only once)
  // It reads from the ref to get current values, but passes selectedSection directly to force re-render
  const InFrontOfTheCanvasComponent = React.useMemo(() => {
    return () => {
      const props = sidebarPropsRef.current;
      // Centralised: respects the guest bypass (guests don't see the
      // format-selector empty state unless they explicitly click
      // "+ New Design", which sets ?newDesign=true).
      const showEmptyState = useIsBuilderEmptyState();

      if (!props.isLoaded) return null;

      return (
        <>
          {showEmptyState && <FlyerBuilderEmptyState sidebarExpanded={!!selectedSection && isShowSidebar} />}
          <SideBar
            store={props.tlStore}
            loading={props.loading}
            setIdFromat={setIdFromat}
            setIsShowCustomStylePanel={setIsShowCustomStylePanel}
            setSelectedSection={handleSidebarSectionChange}
            selectedSection={selectedSection} // Pass directly from state to force re-render on click
            setIsShowSidebar={setIsShowSidebar}
            isShowSidebar={isShowSidebar}
          />
          <ResizingOverlay />
          <CommentsOverlay />
        </>
      );
    };
  }, [selectedSection, isShowSidebar, handleSidebarSectionChange]); // Re-create when selectedSection or isShowSidebar or guest interceptor changes

  // Memoize components object to prevent NewTldraw from re-mounting
  const tldrawComponents = React.useMemo(
    () => ({
      Toolbar: null,
      StylePanel: null,
      NavigationPanel: null,
      DebugMenu: null,
      PageMenu: null,
      HelpMenu: null,
      Spinner: null,
      DebugPanel: null,
      MenuPanel: null,
      ContextMenu: CustomContextMenu,
      InFrontOfTheCanvas: InFrontOfTheCanvasComponent,
    }),
    [InFrontOfTheCanvasComponent]
  );

  // Memoize isShapeHidden to prevent NewTldraw from re-mounting
  const isShapeHidden = React.useCallback((s: any) => !!s.meta.hidden, []);

  // Complete drag and drop implementation with single execution prevention
  React.useEffect(() => {
    // Flag to prevent multiple processing
    let isProcessing = false;

    // Use a timeout to ensure DOM is ready
    const timer = setTimeout(() => {
      const handleDragOver = (e: any) => {
        if (isEmptyStateRef.current) {
          e.preventDefault();
          e.dataTransfer.dropEffect = "none";
          return;
        }
        const target = e.target as HTMLElement;
        if (target?.closest?.("[data-brandkit-dropzone]") || target?.closest?.("[data-variables-dropzone]")) return;
        e.preventDefault();
        e.dataTransfer.dropEffect = "copy";
      };

      const handleDrop = async (e: any) => {
        if (isEmptyStateRef.current) {
          e.preventDefault();
          return;
        }
        const target = e.target as HTMLElement;
        if (target?.closest?.("[data-brandkit-dropzone]") || target?.closest?.("[data-variables-dropzone]")) return;
        e.preventDefault();

        // Prevent multiple processing
        if (isProcessing) {
          return;
        }
        isProcessing = true;

        if (e.dataTransfer?.files?.length) {
          const files = Array.from(e.dataTransfer.files) as File[];

          // Get drop position
          const rect = e.currentTarget.getBoundingClientRect();
          const dropPoint = {
            x: e.clientX - rect.left,
            y: e.clientY - rect.top,
          };

          // Process images using the same logic as TldrawApp
          const imageFiles = files.filter((file) => file.type.startsWith("image/"));

          if (imageFiles.length === 0) {
            return;
          }

          // Try to use the new editor if available
          const newEditor = (window as any).tldrawEditor;
          if (!newEditor || typeof newEditor.createShapes !== "function") {
            return;
          }

          // Convert screen coordinates to page coordinates
          const pagePoint = newEditor.screenToPage({ x: dropPoint.x, y: dropPoint.y });

          // Process each image file
          for (const file of imageFiles) {
            try {
              // Use onAssetCreate callback if available (handles S3 upload for large files)
              let dataUrl: string;
              if (onAssetCreate) {
                const result = await onAssetCreate(file, `temp-${Date.now()}`);
                if (!result) {
                  console.error("❌ [Drag & Drop] Asset creation failed");
                  continue;
                }
                dataUrl = result;
              } else {
                // Fallback to base64 if no callback
                dataUrl = await new Promise<string>((resolve, reject) => {
                  const reader = new FileReader();
                  reader.onload = () => resolve(reader.result as string);
                  reader.onerror = reject;
                  reader.readAsDataURL(file);
                });
              }

              // Create a temporary image to get dimensions and aspect ratio
              const tempUrl = URL.createObjectURL(file);
              const img = (doc as any).createElement("img");
              img.src = tempUrl;

              await new Promise<void>((resolve) => {
                img.onload = () => {
                  let imageWidth = img.width;
                  let imageHeight = img.height;
                  const aspectRatio = imageWidth / imageHeight;
                  const orientation = aspectRatio > 1 ? "landscape" : "portrait";

                  // Use the same sizing logic as the Unsplash upload button
                  if (orientation === "landscape") {
                    imageWidth = 500; // Default width
                    imageHeight = imageWidth / aspectRatio;
                  } else {
                    imageHeight = 500; // Default height
                    imageWidth = imageHeight * aspectRatio;
                  }

                  const assetId = `asset:${file.name}-${Date.now()}`;
                  const shapeId = `shape:${file.name}-${Date.now()}`;

                  // Create the asset first (same as Unsplash upload)
                  newEditor.createAssets([
                    {
                      id: assetId as any,
                      type: "image",
                      typeName: "asset",
                      props: {
                        name: file.name,
                        src: dataUrl,
                        w: imageWidth,
                        h: imageHeight,
                        mimeType: file.type,
                        isAnimated: false,
                      },
                      meta: {
                        name: file.name,
                      },
                    },
                  ]);

                  // Create the shape with minimal props (same as Unsplash upload)
                  newEditor.createShapes([
                    {
                      id: shapeId as any,
                      type: "customImage",
                      props: {
                        assetId,
                        w: imageWidth,
                        h: imageHeight,
                      },
                      x: pagePoint.x - imageWidth / 2, // Center on drop point
                      y: pagePoint.y - imageHeight / 2,
                    },
                  ]);

                  // Switch to select tool and select the new shape
                  newEditor.setCurrentTool("select");
                  newEditor.select(shapeId);

                  URL.revokeObjectURL(tempUrl);
                  resolve();
                };
              });
            } catch (error) {
              console.error("❌ Error processing dropped image:", file.name, error);
            }
          }

          // Reset processing flag after all images are processed
          isProcessing = false;
        } else {
          // No files, reset flag immediately
          isProcessing = false;
        }
      };

      // Get DOM elements using window.document
      const win = window as any;
      const doc = win.document;

      if (!doc) {
        return;
      }

      // Try multiple elements
      const elements: any[] = [];

      if ((doc as any).body) elements.push((doc as any).body);
      if ((doc as any).documentElement) elements.push((doc as any).documentElement);
      if (doc.querySelector) {
        const tldrawContainer = doc.querySelector(".tldraw-container");
        if (tldrawContainer) elements.push(tldrawContainer);

        const dataTldraw = doc.querySelector("[data-tldraw]");
        if (dataTldraw) elements.push(dataTldraw);

        const canvas = doc.querySelector("canvas");
        if (canvas) elements.push(canvas);

        const svg = doc.querySelector("svg");
        if (svg) elements.push(svg);
      }

      elements.forEach((el) => {
        if (el) {
          el.addEventListener("dragover", handleDragOver);
          el.addEventListener("drop", handleDrop);
        }
      });

      // Store cleanup
      win.cleanupDragDrop = () => {
        elements.forEach((el) => {
          if (el) {
            el.removeEventListener("dragover", handleDragOver);
            el.removeEventListener("drop", handleDrop);
          }
        });
      };
    }, 1000);

    return () => {
      clearTimeout(timer);
      const win = window as any;
      if (win.cleanupDragDrop) {
        win.cleanupDragDrop();
      }
    };
  }, [onAssetCreate]);

  return (
    <StyledLayout
      className={cn("tldraw-container", {
        "tldraw-container-dark": settings.isDarkMode,
        "tldraw-container-integrated": isIntegrated,
      })}
      tabIndex={-0}
      style={{
        touchAction: "none",
        overscrollBehavior: "none",
        WebkitTouchCallout: "none",
        WebkitUserSelect: "none",
        userSelect: "none",
      }}
    >
      {isBlocked ? <BlockingOverlay /> : null}
      <Loading />
      <OrientationChangeLoader />
      <div className={cn(styles.page)}>
        <ConfirmPopup
          isOpen={isOpenPopup}
          onClose={() => setIsOpenPopup(false)}
          onSave={onSave}
          onSkip={onSkip}
          loading={app.isLoading}
          title="Save your progress?"
          body="If you quit without saving, all your progress will be lost. Do you want to save campaign progress in draft so
          you can finish it later?"
          showSkipButton
        />
        <AddressBoxWarningModal
          open={showAddressBoxWarning}
          onConfirmAndLeave={handleConfirmAndLeave}
          onAddAddressBox={handleAddAddressBoxFromModal}
        />
        <div className={styles.headerWrapper}>
          <Header
            maxWidth={false}
            headerActions={headerActions}
            flyerActions={mainNavActions}
            isFlyerBuilderPage
            isBackLoading={isExporting}
          />
        </div>
        <div className={styles.drawerWrapper}>
          <div className={styles.drawer} ref={rWrapper}>
            <OneOff focusableRef={rWrapper} autofocus={autofocus} />
            <ContextMenu>
              <div style={{ position: "fixed", inset: 0 }}>
                <NewTldraw
                  key="stable-tldraw-instance"
                  autoFocus
                  store={tlStore}
                  user={tlUser}
                  // @ts-ignore
                  shapeUtils={MyCustomShapes}
                  overrides={uiOverrides}
                  tools={MyCustomTools}
                  onMount={(editor) => {
                    console.log("🔧 Editor mounted");

                    // Make the editor instance available globally for keyboard shortcuts
                    (window as any).tldrawEditor = editor;

                    // Set editor instance for mask group listener
                    setEditorInstance(editor);

                    const handleUndoRedoKeydown = (e: KeyboardEvent) => {
                      const isMac = navigator.platform.toUpperCase().indexOf("MAC") >= 0;
                      const modKey = isMac ? e.metaKey : e.ctrlKey;
                      if (modKey && e.key === "z") {
                        if ((useStore.getState() as StoreType).isOrientationChanging) return;

                        // Capture shape:front dims BEFORE tldraw processes undo/redo
                        const frontBefore = editor.getShape("shape:front" as any);
                        const prevW = (frontBefore as any)?.props?.w;
                        const prevH = (frontBefore as any)?.props?.h;

                        // After tldraw processes, compare dims
                        setTimeout(() => {
                          const frontAfter = editor.getShape("shape:front" as any);
                          const newW = (frontAfter as any)?.props?.w;
                          const newH = (frontAfter as any)?.props?.h;

                          // If shape:front dimensions changed, an orientation change was undone/redone
                          // Simply flip the current store value (works for ALL formats, including inverted ones)
                          if (prevW && prevH && newW && newH && (prevW !== newW || prevH !== newH)) {
                            const storeState = useStore.getState() as StoreType;
                            const flipped = storeState.currentOrientations === "Portrait" ? "Landscape" : "Portrait";
                            // Orientation undo/redo detected — flip store value
                            storeState.setIsUndoOrientationSync(true);
                            storeState.setCurrentOrientations(flipped);
                            const { designId, campaignId } = extractIDsFromURL();
                            setStoredOrientation(flipped, designId, campaignId);
                          }
                        }, 150);
                      }
                    };
                    // Use capture phase so we fire even if tldraw stops propagation
                    window.addEventListener("keydown", handleUndoRedoKeydown, true);

                    // Fix text geometry after fonts load on page reload
                    // Wait for custom fonts to be loaded before attempting resize
                    const fixTextGeometry = () => {
                      const textShapes = editor.getCurrentPageShapes().filter((s: any) => s.type === "customText");
                      const globalDoc = globalThis.document as Document;
                      if (textShapes.length > 0 && globalDoc.fonts) {
                        // Wait for fonts to load, then force MobX to recalculate geometry cache
                        const fontLoadPromises = textShapes.map((shape: any) => {
                          const font = shape.props.font || "Inter";
                          const size = shape.props.size || 18;
                          return globalDoc.fonts.load(`${size}px "${font}"`).catch(() => {});
                        });

                        Promise.all(fontLoadPromises).then(() => {
                          setTimeout(() => {
                            // Force React to re-render all text shapes by toggling a dummy prop
                            textShapes.forEach((shape: any) => {
                              const currentIndicator = shape.props.isShowIndicator;
                              editor.updateShapes([
                                {
                                  id: shape.id,
                                  type: shape.type,
                                  props: { isShowIndicator: !currentIndicator },
                                },
                              ]);
                            });

                            setTimeout(() => {
                              textShapes.forEach((shape: any) => {
                                const currentIndicator = shape.props.isShowIndicator;
                                editor.updateShapes([
                                  {
                                    id: shape.id,
                                    type: shape.type,
                                    props: { isShowIndicator: currentIndicator },
                                  },
                                ]);
                              });
                            }, 20);
                          }, 500);
                        });
                      }
                    };

                    // Initial attempt after a delay
                    setTimeout(fixTextGeometry, 1000);

                    // Also store editor reference for useEffect to use
                    (window as any).__tldrawEditorForFontFix = editor;

                    // Dedup guard for paste events across multiple handlers
                    const getLastPasteTs = () => (window as any).__fbLastPasteTs || 0;
                    const setLastPasteTs = () => ((window as any).__fbLastPasteTs = Date.now());
                    const pastedRecently = (ms = 200) => Date.now() - getLastPasteTs() < ms;
                    const tryStartPaste = (ms = 200) => {
                      if (pastedRecently(ms)) return false;
                      setLastPasteTs();
                      return true;
                    };

                    // Register custom external content handler for images and PDFs
                    editor.registerExternalContentHandler("files", async ({ files, point }) => {
                      // Filter for PDF files
                      const pdfFiles = files.filter(
                        (file) => file.type === "application/pdf" || file.name.toLowerCase().endsWith(".pdf")
                      );

                      if (pdfFiles.length > 0) {
                        // Handle PDF files
                        console.log("PDF files dropped on canvas:", pdfFiles);
                        return importPdfFile(pdfFiles[0], editor);
                      }

                      // Handle image files
                      const imageFiles = files.filter(
                        (file) => file.type.startsWith("image/") || /\.(jpg|jpeg|png|gif|webp|svg)$/i.test(file.name)
                      );

                      if (imageFiles.length > 0) {
                        // Process each image file
                        for (const file of imageFiles) {
                          const reader = new FileReader();

                          reader.onload = (e: any) => {
                            const src = e.target.result;
                            const tempUrl = URL.createObjectURL(file);

                            // @ts-ignore
                            const img = window.document.createElement("img");
                            img.src = tempUrl;

                            img.onload = () => {
                              const aspectRatio = img.width / img.height;
                              const safeName = file.name && file.name.trim().length ? file.name : "pasted-image";
                              const assetId = `asset:${safeName}-${Date.now()}`;

                              // Use reasonable default dimensions
                              const imageWidth = 200;
                              const imageHeight = imageWidth / aspectRatio;

                              // Get drop position or center
                              const dropPoint =
                                point ||
                                editor.screenToPage({
                                  x: editor.getViewportScreenBounds().width / 2,
                                  y: editor.getViewportScreenBounds().height / 2,
                                });

                              // Create asset
                              editor.createAssets([
                                {
                                  id: assetId as any,
                                  type: "image",
                                  typeName: "asset",
                                  props: {
                                    name: safeName,
                                    src: src,
                                    w: imageWidth,
                                    h: imageHeight,
                                    mimeType: file.type || "image/png",
                                    isAnimated: false,
                                  },
                                  meta: { name: safeName },
                                },
                              ]);

                              // Create shape at drop position
                              editor.createShapes([
                                {
                                  id: `shape:${safeName}-${Date.now()}` as any,
                                  type: "customImage",
                                  props: {
                                    assetId,
                                    w: imageWidth,
                                    h: imageHeight,
                                  },
                                  x: dropPoint.x - imageWidth / 2,
                                  y: dropPoint.y - imageHeight / 2,
                                },
                              ]);

                              URL.revokeObjectURL(tempUrl);
                            };
                          };

                          reader.readAsDataURL(file);
                        }

                        // Return null to indicate we handled it
                        return null;
                      }

                      // Let other files be handled normally by Tldraw
                      return undefined;
                    });

                    // Note: multi-URL paste is handled by the single 'url' handler below on most versions.

                    // Register handler for a single URL clipboard type
                    editor.registerExternalContentHandler("url", async ({ url, point }) => {
                      try {
                        const urlText = String(url ?? "").trim();
                        if (!urlText) return undefined;

                        const viewport = editor.getViewportScreenBounds();
                        const center = point || editor.screenToPage({ x: viewport.width / 2, y: viewport.height / 2 });

                        // If the URL looks like an image, create an image shape instead of text
                        const looksLikeImage = /\.(png|jpe?g|gif|webp|svg)(\?.*)?$/i.test(urlText);
                        if (looksLikeImage) {
                          // Create a temp image to infer aspect ratio
                          const tempImg = window.document.createElement("img");
                          tempImg.crossOrigin = "anonymous";
                          tempImg.src = urlText;

                          await new Promise<void>((resolve) => {
                            tempImg.onload = () => resolve();
                            tempImg.onerror = () => resolve();
                          });

                          const naturalW = tempImg.naturalWidth || 500;
                          const naturalH = tempImg.naturalHeight || 500;
                          const aspect = naturalW && naturalH ? naturalW / naturalH : 1;
                          const imageWidth = 200;
                          const imageHeight = imageWidth / (aspect || 1);

                          const assetId = `asset:pasted-image-url-${Date.now()}` as any;
                          editor.createAssets([
                            {
                              id: assetId,
                              type: "image",
                              typeName: "asset",
                              props: {
                                name: "pasted-image-url",
                                src: urlText,
                                w: imageWidth,
                                h: imageHeight,
                                mimeType: "image/png",
                                isAnimated: false,
                              },
                              meta: { name: "pasted-image-url" },
                            },
                          ]);

                          const shapeId = `shape:pasted-image-url-${Date.now()}` as any;
                          editor.createShapes([
                            {
                              id: shapeId,
                              type: "customImage",
                              props: { assetId, w: imageWidth, h: imageHeight },
                              x: center.x - imageWidth / 2,
                              y: center.y - imageHeight / 2,
                            },
                          ]);
                          editor.select(shapeId as TLShapeId);
                          return null;
                        }

                        const shapeId = `shape:text-${Date.now()}` as any;
                        editor.createShapes([
                          {
                            id: shapeId,
                            type: "customText",
                            x: center.x - 85,
                            y: center.y - 10,
                            props: {
                              text: urlText,
                              size: 18,
                              font: "Inter",
                              textAlign: "start",
                              w: 170,
                              h: 1,
                              autoSize: true,
                              fill: "#000000",
                              outlineColor: "#000000",
                              transparency: 1,
                              forAbilityEditable: false,
                              fontWeight: 400,
                              underline: "none",
                              lineThrough: "none",
                              italic: "normal",
                              textJustify: "none",
                              strokeWidth: 0,
                              lineHeight: 1,
                              letterSpacing: 1,
                              borderWidth: 0,
                              borderColor: "#000000",
                              borderSolid: "solid",
                              borderTopStyle: "solid",
                              borderBottomStyle: "solid",
                              borderLeftStyle: "solid",
                              borderRightStyle: "solid",
                              isShowBorderTop: true,
                              isShowBorderBottom: true,
                              isShowBorderLeft: true,
                              isShowBorderRight: true,
                              rounded: 0,
                              filterBlur: 0,
                              flipH: false,
                              flipV: false,
                              isCreatedFilterBlur: false,
                              filterBlurValueWhenHidden: 0,
                              outShadowArray: {},
                              inShadowArray: {},
                              previousBorderColor: "#000000",
                              isCreatedBorderItem: false,
                              colorMix: {
                                "0": { color: "#000000", isHidden: false },
                              },
                              outlineColorMix: {},
                              isHiddenLayerBlur: false,
                              isHiddenBorder: false,
                              isShowIndicator: false,
                              isScale: false,
                              scale: 1,
                            },
                          },
                        ]);
                        editor.select(shapeId as TLShapeId);

                        return null;
                      } catch {
                        return undefined;
                      }
                    });

                    // Intercept embed URLs and paste as plain text instead of bookmark/preview
                    editor.registerExternalContentHandler("embed", async (payload: any) => {
                      try {
                        const urlText = String(payload?.url ?? "").trim();
                        if (!urlText) return undefined;

                        const viewport = editor.getViewportScreenBounds();
                        const center =
                          payload?.point || editor.screenToPage({ x: viewport.width / 2, y: viewport.height / 2 });

                        const shapeId = `shape:text-${Date.now()}` as any;
                        editor.createShapes([
                          {
                            id: shapeId,
                            type: "customText",
                            x: center.x - 85,
                            y: center.y - 10,
                            props: {
                              text: urlText,
                              size: 18,
                              font: "Inter",
                              textAlign: "start",
                              w: 170,
                              h: 1,
                              autoSize: true,
                              fill: "#000000",
                              outlineColor: "#000000",
                              transparency: 1,
                              forAbilityEditable: false,
                              fontWeight: 400,
                              underline: "none",
                              lineThrough: "none",
                              italic: "normal",
                              textJustify: "none",
                              strokeWidth: 0,
                              lineHeight: 1,
                              letterSpacing: 1,
                              borderWidth: 0,
                              borderColor: "#000000",
                              borderSolid: "solid",
                              borderTopStyle: "solid",
                              borderBottomStyle: "solid",
                              borderLeftStyle: "solid",
                              borderRightStyle: "solid",
                              isShowBorderTop: true,
                              isShowBorderBottom: true,
                              isShowBorderLeft: true,
                              isShowBorderRight: true,
                              rounded: 0,
                              filterBlur: 0,
                              flipH: false,
                              flipV: false,
                              isCreatedFilterBlur: false,
                              filterBlurValueWhenHidden: 0,
                              outShadowArray: {},
                              inShadowArray: {},
                              previousBorderColor: "#000000",
                              isCreatedBorderItem: false,
                              colorMix: {
                                "0": { color: "#000000", isHidden: false },
                              },
                              outlineColorMix: {},
                              isHiddenLayerBlur: false,
                              isHiddenBorder: false,
                              isShowIndicator: false,
                              isScale: false,
                              scale: 1,
                            },
                          },
                        ]);
                        editor.select(shapeId as TLShapeId);

                        return null;
                      } catch {
                        return undefined;
                      }
                    });

                    // Register custom external content handler for plain text (pastes)
                    editor.registerExternalContentHandler("text", async ({ text, point }) => {
                      try {
                        const content = (text || "").trim();
                        // Let Tldraw handle text/URL paste; DOM paste handler will ignore text
                        // If there's no textual content, try reading clipboard images (Copy Image scenario)
                        if (!content) {
                          if (!tryStartPaste()) return null;
                          try {
                            // Some browsers provide image blobs via the async clipboard API during paste
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            const canReadClipboard = typeof (navigator as any)?.clipboard?.read === "function";
                            if (canReadClipboard) {
                              // eslint-disable-next-line @typescript-eslint/no-explicit-any
                              const items: any[] = await (navigator as any).clipboard.read();
                              for (const item of items) {
                                const imageType = item.types?.find?.((t: string) => t.startsWith("image/"));
                                if (!imageType) continue;
                                const blob: Blob = await item.getType(imageType);

                                // Convert blob to data URL (valid protocol for assets) and get dimensions
                                const dataUrl = await new Promise<string>((resolve, reject) => {
                                  const fr = new FileReader();
                                  fr.onload = () => resolve(fr.result as string);
                                  fr.onerror = reject;
                                  fr.readAsDataURL(blob);
                                });
                                const tmp = window.document.createElement("img");
                                tmp.src = dataUrl;
                                await new Promise<void>((resolve) => {
                                  tmp.onload = () => resolve();
                                  tmp.onerror = () => resolve();
                                });

                                const naturalW = tmp.naturalWidth || 500;
                                const naturalH = tmp.naturalHeight || 500;
                                const aspect = naturalW && naturalH ? naturalW / naturalH : 1;
                                const imageWidth = 200;
                                const imageHeight = imageWidth / (aspect || 1);

                                const viewport = editor.getViewportScreenBounds();
                                const center =
                                  point || editor.screenToPage({ x: viewport.width / 2, y: viewport.height / 2 });

                                const assetId = `asset:clipboard-image-${Date.now()}` as any;
                                editor.createAssets([
                                  {
                                    id: assetId,
                                    type: "image",
                                    typeName: "asset",
                                    props: {
                                      name: "clipboard-image",
                                      src: dataUrl,
                                      w: imageWidth,
                                      h: imageHeight,
                                      mimeType: blob.type || "image/png",
                                      isAnimated: false,
                                    },
                                    meta: { name: "clipboard-image" },
                                  },
                                ]);

                                const shapeId = `shape:clipboard-image-${Date.now()}-${Math.random()
                                  .toString(36)
                                  .slice(2)}` as any;
                                editor.createShapes([
                                  {
                                    id: shapeId,
                                    type: "customImage",
                                    props: { assetId, w: imageWidth, h: imageHeight },
                                    x: center.x - imageWidth / 2,
                                    y: center.y - imageHeight / 2,
                                  },
                                ]);
                                editor.select(shapeId as TLShapeId);

                                return null;
                              }
                            }
                          } catch {
                            // Ignore and fall back to default behavior
                          }
                          return null; // handled or ignored
                        }

                        // Handle the legacy `tldr/clipboard` JSON format written by
                        // `TldrawApp.copy()` (see state/TldrawApp.ts). Tldraw v3 uses a
                        // different on-clipboard format (text/html with a base64-encoded
                        // `<div data-tldraw>` payload) and does NOT recognize this legacy
                        // text/plain JSON. Previously this branch returned `undefined`
                        // expecting tldraw to handle it — but v3 doesn't, so the giant
                        // JSON ended up pasted as a text shape. With many shapes
                        // (e.g. 2048) this manifests as the whole `tldr/clipboard` JSON
                        // appearing literally on the canvas.
                        //
                        // Fix: parse the JSON ourselves and instantiate the shapes via
                        // `editor.createShapes()`. New IDs are generated to allow paste
                        // alongside the original selection, and positions are shifted so
                        // the cluster lands centered on the paste point (or canvas center
                        // when no point is given, e.g. keyboard shortcut paste).
                        try {
                          const maybeJson = JSON.parse(content);
                          if (
                            maybeJson &&
                            maybeJson.type === "tldr/clipboard" &&
                            Array.isArray(maybeJson.shapes) &&
                            maybeJson.shapes.length > 0
                          ) {
                            const sourceShapes = maybeJson.shapes as any[];

                            // Read both v3 (`x`, `props.w/h`) and v1 (`point`, `size`)
                            // fields because the legacy copy writes a hybrid.
                            const getX = (s: any) =>
                              typeof s.x === "number" ? s.x : Array.isArray(s.point) ? s.point[0] : 0;
                            const getY = (s: any) =>
                              typeof s.y === "number" ? s.y : Array.isArray(s.point) ? s.point[1] : 0;
                            const getW = (s: any) =>
                              typeof s?.props?.w === "number" ? s.props.w : Array.isArray(s.size) ? s.size[0] : 0;
                            const getH = (s: any) =>
                              typeof s?.props?.h === "number" ? s.props.h : Array.isArray(s.size) ? s.size[1] : 0;

                            // Single-pass bounding box. The previous version did 6
                            // array allocations (xs/ys/ws/hs + 2 derived arrays
                            // inside Math.max(...spread)) and 4 spread calls — fine
                            // for small pastes, wasteful past ~128 shapes.
                            let minX = Infinity;
                            let minY = Infinity;
                            let maxX = -Infinity;
                            let maxY = -Infinity;
                            for (let i = 0; i < sourceShapes.length; i++) {
                              const s = sourceShapes[i];
                              const x = getX(s);
                              const y = getY(s);
                              const x2 = x + getW(s);
                              const y2 = y + getH(s);
                              if (x < minX) minX = x;
                              if (y < minY) minY = y;
                              if (x2 > maxX) maxX = x2;
                              if (y2 > maxY) maxY = y2;
                            }

                            const viewport = editor.getViewportScreenBounds();
                            const center =
                              point || editor.screenToPage({ x: viewport.width / 2, y: viewport.height / 2 });
                            const offsetX = center.x - (minX + maxX) / 2;
                            const offsetY = center.y - (minY + maxY) / 2;

                            // Re-id and shift each shape. One `Date.now()` shared
                            // across the paste + array index keeps IDs unique without
                            // the per-shape `Math.random()` call. Strip legacy v1
                            // fields so v3's schema validator doesn't complain.
                            const pasteTs = Date.now();
                            const newShapes = sourceShapes.map((s, i) => {
                              const {
                                point: _p,
                                size: _s,
                                style: _st,
                                childIndex: _ci,
                                parentId: _pi,
                                index: _ix,
                                ...rest
                              } = s;
                              return {
                                ...rest,
                                id: `shape:pasted-${pasteTs}-${i}`,
                                x: getX(s) + offsetX,
                                y: getY(s) + offsetY,
                              };
                            });
                            const newIds = newShapes.map((s) => s.id);

                            // Atomic transaction: create + select in one batch so
                            // reactive subscribers tick once instead of twice. With
                            // 128+ shape pastes the second cascade (from the select
                            // call) was paying the same cost as the create — half
                            // the post-paste lag comes from skipping it.
                            // `setSelectedShapes(array)` instead of `select(...spread)`
                            // avoids the N-argument spread call.
                            editor.run(() => {
                              editor.createShapes(newShapes as any);
                              editor.setSelectedShapes(newIds as any);
                            });
                            return null;
                          }
                        } catch (e) {
                          // not JSON → treat as external plain text
                        }

                        // If the text contains an <img> tag, try to paste that image
                        const imgSrcs: string[] = [];
                        if (content.toLowerCase().includes("<img")) {
                          const match = content.match(/<img[^>]+src=["']([^"']+)["']/i);
                          if (match && match[1]) imgSrcs.push(match[1]);
                        }

                        // If the text itself is a URL that looks like an image, treat it as image too
                        const isImageUrl = /\.(png|jpe?g|gif|webp|svg)(\?.*)?$/i.test(content);
                        if (isImageUrl) imgSrcs.push(content);

                        if (imgSrcs.length > 0) {
                          const viewport = editor.getViewportScreenBounds();
                          const center =
                            point || editor.screenToPage({ x: viewport.width / 2, y: viewport.height / 2 });

                          const placed: string[] = [];
                          for (const srcUrl of imgSrcs) {
                            // Create temp image to get ratio; do not block if it fails
                            const tempImg = window.document.createElement("img");
                            tempImg.crossOrigin = "anonymous";
                            tempImg.src = srcUrl;
                            await new Promise<void>((resolve) => {
                              tempImg.onload = () => resolve();
                              tempImg.onerror = () => resolve();
                            });

                            const naturalW = tempImg.naturalWidth || 500;
                            const naturalH = tempImg.naturalHeight || 500;
                            const aspect = naturalW && naturalH ? naturalW / naturalH : 1;
                            const imageWidth = 200;
                            const imageHeight = imageWidth / (aspect || 1);

                            const assetId = `asset:pasted-image-text-${Date.now()}-${Math.random()
                              .toString(36)
                              .slice(2)}` as any;
                            editor.createAssets([
                              {
                                id: assetId,
                                type: "image",
                                typeName: "asset",
                                props: {
                                  name: "pasted-image",
                                  src: srcUrl,
                                  w: imageWidth,
                                  h: imageHeight,
                                  mimeType: "image/png",
                                  isAnimated: false,
                                },
                                meta: { name: "pasted-image" },
                              },
                            ]);

                            const shapeId = `shape:pasted-image-text-${Date.now()}-${Math.random()
                              .toString(36)
                              .slice(2)}` as any;
                            editor.createShapes([
                              {
                                id: shapeId,
                                type: "customImage",
                                props: { assetId, w: imageWidth, h: imageHeight },
                                x: center.x - imageWidth / 2 + placed.length * (imageWidth + 16),
                                y: center.y - imageHeight / 2,
                              },
                            ]);
                            placed.push(shapeId);
                          }
                          if (placed.length) editor.select(placed[placed.length - 1] as TLShapeId);
                          return null;
                        }

                        // Otherwise paste as plain text shape
                        const viewport = editor.getViewportScreenBounds();
                        const center = point || editor.screenToPage({ x: viewport.width / 2, y: viewport.height / 2 });

                        // Read Brand Kit default font
                        // Checks localStorage first, then Zustand store as fallback for fresh sessions
                        let pasteFont = "Inter";
                        let pasteFontSize = 18;
                        let pasteLineHeight = 1;
                        let pasteLetterSpacing = 1;
                        try {
                          const presetStr = localStorage.getItem("brandDefaultFontPreset");
                          if (presetStr) {
                            const preset = JSON.parse(presetStr);
                            if (preset.fontFamily) pasteFont = preset.fontFamily;
                            if (preset.fontSize) pasteFontSize = preset.fontSize;
                            if (preset.lineHeight) pasteLineHeight = preset.lineHeight;
                            if (preset.letterSpacing) pasteLetterSpacing = preset.letterSpacing;
                          } else {
                            const lastFont = localStorage.getItem("lastSelectedFont");
                            if (lastFont) {
                              pasteFont = lastFont;
                            } else {
                              // Fallback: read from Zustand store (fresh session, localStorage empty)
                              try {
                                const storePresets = useBrandKitStore.getState().fontPresets;
                                if (storePresets && storePresets.length > 0) {
                                  const p = storePresets[0];
                                  if (p.fontFamily) pasteFont = p.fontFamily;
                                  if (p.fontSize) pasteFontSize = p.fontSize;
                                  if (p.lineHeight) pasteLineHeight = p.lineHeight;
                                  if (p.letterSpacing) pasteLetterSpacing = p.letterSpacing;
                                }
                              } catch {
                                /* store not available */
                              }
                            }
                          }
                        } catch {
                          /* ignore */
                        }

                        const shapeId = `shape:text-${Date.now()}` as any;
                        editor.createShapes([
                          {
                            id: shapeId,
                            type: "customText",
                            x: center.x - 85,
                            y: center.y - 10,
                            props: {
                              text: content,
                              size: pasteFontSize,
                              font: pasteFont,
                              textAlign: "start",
                              w: 170,
                              h: 1,
                              autoSize: true,
                              fill: "#000000",
                              outlineColor: "#000000",
                              transparency: 1,
                              forAbilityEditable: false,
                              fontWeight: 400,
                              underline: "none",
                              lineThrough: "none",
                              italic: "normal",
                              textJustify: "none",
                              strokeWidth: 0,
                              lineHeight: pasteLineHeight,
                              letterSpacing: pasteLetterSpacing,
                              borderWidth: 0,
                              borderColor: "#000000",
                              borderSolid: "solid",
                              borderTopStyle: "solid",
                              borderBottomStyle: "solid",
                              borderLeftStyle: "solid",
                              borderRightStyle: "solid",
                              isShowBorderTop: true,
                              isShowBorderBottom: true,
                              isShowBorderLeft: true,
                              isShowBorderRight: true,
                              rounded: 0,
                              filterBlur: 0,
                              flipH: false,
                              flipV: false,
                              isCreatedFilterBlur: false,
                              filterBlurValueWhenHidden: 0,
                              outShadowArray: {},
                              inShadowArray: {},
                              previousBorderColor: "#000000",
                              isCreatedBorderItem: false,
                              colorMix: {
                                "0": { color: "#000000", isHidden: false },
                              },
                              outlineColorMix: {},
                              isHiddenLayerBlur: false,
                              isHiddenBorder: false,
                              isShowIndicator: false,
                              isScale: false,
                              scale: 1,
                            },
                          },
                        ]);
                        editor.select(shapeId as TLShapeId);

                        return null;
                      } catch {
                        // Fall back to default handling if something goes wrong
                        return undefined;
                      }
                    });

                    // Fallback: intercept DOM paste to handle clipboard image blobs (Copy Image)
                    // AND plain text paste when tldraw's internal paste didn't create anything
                    // (e.g., text copied from inside a textbox then pasted outside)
                    const domPasteHandler = async (e: ClipboardEvent) => {
                      // Ignore pastes that originate from editable form fields
                      const pasteTarget = e.target as HTMLElement | null;
                      if (pasteTarget) {
                        const tag = pasteTarget.tagName;
                        if (tag === "INPUT" || tag === "TEXTAREA" || pasteTarget.isContentEditable) {
                          return;
                        }
                      }
                      if (!tryStartPaste()) return;
                      try {
                        const items = e.clipboardData?.items;
                        if (!items || !items.length) return;
                        const imageItems = Array.from(items).filter(
                          (it) => it.kind === "file" && it.type.startsWith("image/")
                        );

                        // If no image items, check for plain text — but only handle it
                        // if the registerExternalContentHandler("text") didn't already create a shape.
                        // We use a small delay to let tldraw's handler run first.
                        if (imageItems.length === 0) {
                          const plainText = e.clipboardData?.getData("text/plain")?.trim();
                          if (plainText && !editor.getEditingShapeId()) {
                            // Wait briefly to see if tldraw's external content handler already created a shape
                            const shapesBefore = editor.getSortedChildIdsForParent(editor.getCurrentPageId()).length;
                            await new Promise((r) => setTimeout(r, 100));
                            const shapesAfter = editor.getSortedChildIdsForParent(editor.getCurrentPageId()).length;

                            // If tldraw already created a shape, don't create another
                            if (shapesAfter > shapesBefore) return;

                            e.preventDefault();

                            // Read Brand Kit font with full preset attributes
                            let pFont = "Inter";
                            let pFontSize = 18;
                            let pLineHeight = 1;
                            let pLetterSpacing = 1;
                            let pFontWeight = 400;
                            let pItalic = "normal";
                            let pUnderline = "none";
                            try {
                              const bkStr = localStorage.getItem("brandDefaultFontPreset");
                              if (bkStr) {
                                const bk = JSON.parse(bkStr);
                                // Use fontVariant base as font (matches TextParameters.handleApplyFontPreset)
                                const baseVariant = bk.fontVariant ? bk.fontVariant.split(":")[0] : null;
                                if (baseVariant) {
                                  pFont = baseVariant;
                                } else if (bk.fontFamily) {
                                  pFont = bk.fontFamily;
                                }
                                if (bk.fontSize) pFontSize = bk.fontSize;
                                if (bk.lineHeight) pLineHeight = bk.lineHeight;
                                if (bk.letterSpacing) pLetterSpacing = bk.letterSpacing;
                                // Parse weight/italic from fontVariant
                                if (bk.fontVariant) {
                                  const parts = bk.fontVariant.split(":");
                                  if (parts.includes("i")) pItalic = "italic";
                                  if (parts.includes("u")) pUnderline = "underline";
                                  let suffix = "";
                                  if (bk.fontFamily) {
                                    suffix = parts[0].slice(bk.fontFamily.length).replace(/^[-_]/, "").toLowerCase();
                                  }
                                  if (suffix.endsWith("it") || suffix.endsWith("italic")) pItalic = "italic";
                                  const ws = suffix.replace(/i(?:t(?:alic)?)?$/, "").trim();
                                  const WM: Record<string, number> = {
                                    thin: 100,
                                    extralight: 200,
                                    light: 300,
                                    "": 400,
                                    regular: 400,
                                    medium: 500,
                                    semibold: 600,
                                    bold: 700,
                                    extrabold: 800,
                                    black: 900,
                                  };
                                  if (ws && WM[ws] !== undefined) pFontWeight = WM[ws];
                                }
                              } else {
                                const lf = localStorage.getItem("lastSelectedFont");
                                if (lf) pFont = lf;
                              }
                            } catch {
                              /* ignore */
                            }

                            const viewport = editor.getViewportScreenBounds();
                            const center = editor.screenToPage({ x: viewport.width / 2, y: viewport.height / 2 });
                            const shapeId = `shape:text-fallback-${Date.now()}` as any;

                            editor.createShapes([
                              {
                                id: shapeId,
                                type: "customText",
                                x: center.x - 85 + 5,
                                y: center.y - 10 + 5,
                                props: {
                                  text: plainText,
                                  size: pFontSize,
                                  font: pFont,
                                  textAlign: "start",
                                  w: 170,
                                  h: 1,
                                  autoSize: true,
                                  fill: "#000000",
                                  outlineColor: "#000000",
                                  transparency: 1,
                                  forAbilityEditable: false,
                                  fontWeight: pFontWeight,
                                  underline: pUnderline,
                                  lineThrough: "none",
                                  italic: pItalic,
                                  textJustify: "none",
                                  strokeWidth: 0,
                                  lineHeight: pLineHeight,
                                  letterSpacing: pLetterSpacing,
                                  borderWidth: 0,
                                  borderColor: "#000000",
                                  borderSolid: "solid",
                                },
                              },
                            ]);
                            editor.select(shapeId as TLShapeId);
                            return;
                          }
                          return;
                        }

                        e.preventDefault();

                        for (const item of imageItems) {
                          const file = item.getAsFile();
                          if (!file) continue;

                          // Convert file to data URL (valid protocol) and infer dimensions
                          const dataUrl = await new Promise<string>((resolve, reject) => {
                            const fr = new FileReader();
                            fr.onload = () => resolve(fr.result as string);
                            fr.onerror = reject;
                            fr.readAsDataURL(file);
                          });
                          const tmp = window.document.createElement("img");
                          tmp.src = dataUrl;
                          await new Promise<void>((resolve) => {
                            tmp.onload = () => resolve();
                            tmp.onerror = () => resolve();
                          });

                          const naturalW = tmp.naturalWidth || 500;
                          const naturalH = tmp.naturalHeight || 500;
                          const aspect = naturalW && naturalH ? naturalW / naturalH : 1;
                          const imageWidth = 200;
                          const imageHeight = imageWidth / (aspect || 1);
                          const viewport = editor.getViewportScreenBounds();
                          const center = editor.screenToPage({ x: viewport.width / 2, y: viewport.height / 2 });

                          const assetId = `asset:clipboard-image-${Date.now()}-${Math.random()
                            .toString(36)
                            .slice(2)}` as any;
                          editor.createAssets([
                            {
                              id: assetId,
                              type: "image",
                              typeName: "asset",
                              props: {
                                name: file.name || "clipboard-image",
                                src: dataUrl,
                                w: imageWidth,
                                h: imageHeight,
                                mimeType: file.type || "image/png",
                                isAnimated: false,
                              },
                              meta: { name: file.name || "clipboard-image" },
                            },
                          ]);

                          const shapeId = `shape:clipboard-image-${Date.now()}-${Math.random()
                            .toString(36)
                            .slice(2)}` as any;
                          editor.createShapes([
                            {
                              id: shapeId,
                              type: "customImage",
                              props: { assetId, w: imageWidth, h: imageHeight },
                              x: center.x - imageWidth / 2,
                              y: center.y - imageHeight / 2,
                            },
                          ]);
                          editor.select(shapeId as TLShapeId);
                          // dataUrl doesn't need revocation
                        }
                      } catch (err) {
                        console.warn("Clipboard image paste failed:", err);
                        // Reset guard on error to avoid lockout
                        (window as any).__fbLastPasteTs = 0;
                      }
                    };
                    window.document.addEventListener("paste", domPasteHandler);
                    (window as any).cleanupImagePaste = () =>
                      window.document.removeEventListener("paste", domPasteHandler);
                  }}
                  components={tldrawComponents}
                  isShapeHidden={isShapeHidden}
                  forceMobile={false}
                  options={options}
                >
                  <HideSelectionOnChange />
                  <ResizeCursorManager />
                  <ScaleResizeCursorManager />
                  <CustomStylePanel
                    isShowCustomStylePanel={isShowCustomStylePanel}
                    idFormat={idFormat}
                    fonts={fonts}
                    setSelectedSection={setSelectedSection}
                  />

                  <Measure />
                  {/* NOTE: QRCodeDuplicateWarning disabled - duplicating QR codes is allowed.
                      Keep commented in case it needs to be re-enabled in the future. */}
                  {/* <QRCodeDuplicateWarning /> */}
                  <BottomToolPanel />
                  <ContextMenuClamp />
                  <DesignSaver
                    saveDesignNow={generateAndSaveDesign}
                    isUspsCompliant={isUspsCompliantFormat}
                    hasAddressBox={hasAddressBox}
                  />
                  <CanvasDragOverlay />
                </NewTldraw>
              </div>
            </ContextMenu>
            {showUI && (
              <StyledUI>{settings.isFocusMode ? <FocusButton onSelect={app.toggleFocusMode} /> : null}</StyledUI>
            )}
          </div>
        </div>
      </div>

      {/* Template Modal */}
      <TemplateModal
        currentDesignId={designId?.toString() || ""}
        open={isTemplateModalOpen}
        onClose={() => setIsTemplateModalOpen(false)}
        onSaveTemplate={handleSaveTemplate}
        onApplyTemplate={handleApplyTemplate}
        onDeleteTemplate={handleDeleteTemplate}
        loading={designManagementLoading}
      />

      {/* Debug Buttons - only visible when fb_debug is true in localStorage */}
      {isDebugMode && (
        <div
          style={{
            position: "fixed",
            top: "120px",
            right: "20px",
            zIndex: 1000,
            display: "flex",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          {/* Custom Font Manager Button */}
          <div
            style={{
              backgroundColor: "#2196f3",
              border: "2px solid #1976d2",
              borderRadius: "8px",
              padding: "8px 12px",
              cursor: "pointer",
              boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
              fontSize: "12px",
              fontWeight: "bold",
              color: "white",
              display: "flex",
              alignItems: "center",
              gap: "6px",
              whiteSpace: "nowrap",
            }}
            onClick={() => setIsCustomFontManagerOpen(true)}
            title="Manage custom fonts"
          >
            🎨 Font Manager
          </div>
        </div>
      )}

      {/* Simple Font Manager Modal */}
      <SimpleFontManager isVisible={isCustomFontManagerOpen} onClose={() => setIsCustomFontManagerOpen(false)} />
      {/* First-time tour — placed outside useMemo to survive sidebar tab changes */}
      <FlyerBuilderTour />
      {/* Guest signup modal — opened from the "Sign Up to Save & Export" header CTA */}
      <SignupModal
        isOpen={isSignupModalOpen}
        onClose={() => setIsSignupModalOpen(false)}
        currentFormat={format}
        currentDesignName={currentDesign?.designName}
      />
      {/* Post-signup full-screen loader — covers the canvas while
          `guest-signup-complete` runs its copy / seed / redirect work.
          Unmounts on page navigation (the redirect at the end of the
          handler), so we never need to flip the flag back to false. */}
      {postSignupUrl ? (
        <div
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 100000,
            background: "#fff",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 14,
            textAlign: "center",
            padding: 24,
            fontFamily: '"Proxima Nova", sans-serif',
          }}
        >
          <p style={{ fontSize: 16, fontWeight: 600, color: "#0C172C", margin: 0 }}>Your design is ready 🎉</p>
          <p style={{ fontSize: 13, color: "#798498", margin: 0 }}>Open it in the Creative Studio to keep editing.</p>
          <button
            onClick={() => window.open(postSignupUrl, "_blank", "noopener")}
            style={{
              padding: "12px 22px",
              background: "#F43F5E",
              color: "#fff",
              border: 0,
              borderRadius: 8,
              fontWeight: 600,
              cursor: "pointer",
              fontFamily: '"Proxima Nova", sans-serif',
            }}
          >
            Open in Creative Studio →
          </button>
        </div>
      ) : (
        isPostSignupLoading && <LoadingUI />
      )}
      {/* Guest feature teaser — opened from sidebar Brand Kit / Variables tabs. The CTA
          inside closes this modal and opens the SignupModal. */}
      <FeatureModal
        isOpen={featureModalType !== null}
        type={featureModalType}
        onClose={() => setFeatureModalType(null)}
        onSignup={() => {
          setFeatureModalType(null);
          setIsSignupModalOpen(true);
        }}
      />
      {/* "Are you sure you want to leave?" confirmation triggered by
          the header Back button in guest mode. Confirming navigates
          away to the marketing site; cancelling dismisses the
          overlay and leaves the canvas untouched. */}
      <LeaveWarningModal
        isOpen={showGuestLeaveWarning}
        onCancel={() => setShowGuestLeaveWarning(false)}
        onConfirm={() => {
          setShowGuestLeaveWarning(false);
          // Same-tab navigation so the browser's session storage,
          // history etc. is cleaned up naturally. The destination is
          // the marketing site for now — a later pass will prefer
          // `document.referrer` when it points at a same-origin
          // page (so "Back" really does go back), falling through to
          // oppizi.com as the default.
          window.location.href = "https://oppizi.com/";
        }}
      />
    </StyledLayout>
  );
});

const OneOff = React.memo(function OneOff({
  focusableRef,
  autofocus,
}: {
  autofocus?: boolean;
  focusableRef: React.RefObject<HTMLDivElement>;
}) {
  useKeyboardShortcuts(focusableRef);
  useStylesheet();

  React.useEffect(() => {
    if (autofocus) {
      focusableRef.current?.focus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autofocus]);

  return null;
});

export const MyCustomShapes = [
  FormatUtilFront,
  BoxForTemplateUtilFront,
  FormatDashBorderFront,
  CustomCloudUtil,
  CustomHeartUtil,
  CustomEllipseUtil,
  CustomOvalUtil,
  CustomRectUtil,
  CustomAddressBoxUtil,
  CustomTriangleUtil,
  CustomStarUtil,
  CustomCheckBoxUtil,
  CustomXBoxUtil,
  CustomTextUtil,
  CustomSvgUtil,
  CustomImageUtil,
  CustomMeasureUtil,
  LabelUtil,
  RedLineUtil,
  FoldLineUtil,
  BlackLineUtil,
  DrawShapeUtil,
  HighlightShapeUtil,
  DoorHangerUtil,
];
export const MyCustomTools = [
  // ScaleTool,
  CustomCloudTool,
  CustomHeartTool,
  CustomEllipseTool,
  CustomOvalTool,
  CustomRectangleTool,
  CustomTriangleTool,
  CustomStarTool,
  CustomCheckboxTool,
  CustomXBoxTool,
  CustomTextTool,
  DrawShapeTool,
  HighlightShapeTool,
  // CustomScale,
];

const DesignSaver = React.memo(function DesignSaver({
  saveDesignNow,
  isUspsCompliant,
  hasAddressBox,
}: {
  saveDesignNow: (isManualSave?: boolean) => Promise<void>;
  isUspsCompliant: boolean;
  hasAddressBox: boolean;
}) {
  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      // If design is USPS compliant and doesn't have address box, warn user FIRST
      if (isUspsCompliant && !hasAddressBox) {
        // Cancel the event to prevent immediate closing
        e.preventDefault();
        // Chrome requires returnValue to be set
        e.returnValue = "";
        // Some browsers show custom message, most show generic warning
        return "";
      }

      // Only save if we're not preventing the unload
      // Use the non-intrusive save for beforeunload
      // Pass false (auto-save) to avoid global state updates on page close
      saveDesignNow(false);
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [saveDesignNow, isUspsCompliant, hasAddressBox]);

  return null;
});
